export enum HttpPaths {
  API_TOGGLE_PRIORITY_EMERGENCY_STATUS = '/api/v1/ServiceCategory/TogglePriorityEmergencyStatus?PriorityId=',
  // Geographic Data APIs

  API_BRANCH_URL = '/api/v1/shared/listofcompanybranches',
  API_AREA_URL = '/api/v1/shared/listofareas',
  API_BLOCK_URL = '/api/v1/shared/listofblocks',

  API_LOGIN_URL = '/api/v1/Auth/token',
  API_REFRESH_TOKEN = '/api/v1/auth/refreshToken',
  API_COMPANYCONFIG_URL = '/api/v1/Auth/CompanyConfiguration',
  API_COMPANYCONFIG_ADMIN_TOOL_URL = '/api/v1/CompanyManager/CheckCompanyIsActiveOrNotWithConfiguration',
  API_LOGINWITH_USERID = '/api/v1/Auth/logout/',
  API_CHECK_USER_USERNAME_EXIST = '/api/v1/auth/IsExistsUserName',
  API_CHECK_USER_PHONE_EXIST = '/api/v1/auth/IsExistsUserPhone',
  API_CHECK_USER_EMAIL_EXIST = '/api/v1/auth/IsExistsUserEmail',

  // Jobs APIS
  API_JOB_ADD = '/api/v1/hr/addjob',
  API_JOB_UPDATE = '/api/v1/hr/updatejob',
  API_JOB_UACTIVEDEACTIVE = '/api/v1/hr/changejobsactiveornot/',
  API_JOB_GETALL = '/api/v2/hr/getjobs',
  API_JOB_DELETE = '/api/v1/hr/deletejob/',
  API_JOB_GETPERSECTION = '/api/v1/hr/GetJobsPerSection/',
  API_JOB_UPDATEJOBPERSECTION = '/api/v1/hr/ManageJobSection',
  API_JOB_GET_LISTJOBPERSECTION = '/api/v1/hr/listofjobspersection',
  API_JOB_GET_LIST = '/api/v1/hr/listofjobs?companyId=',
  API_CHECK_JOB_NAMEEN_EXIST = '/api/v1/hr/IsExistsJobNameEn',
  API_CHECK_JOB_NAMEAR_EXIST = '/api/v1/hr/IsExistsJobNameAr',

  //State APIS
  API_STATE_ADD = '/api/v1/shared/addstate',
  API_STATE_UPDATE = '/api/v1/shared/updatestate/',
  API_STATE_GETALL = '/api/v1/shared/getstates',
  API_STATE_DELETE = '/api/v1/shared/deletestate/',
  API_STATE_UACTIVEDEACTIVE = '/api/v1/shared/changstateactiveornot/',

  //militaryStatus
  API_MILITARYSTATUS_GETLIST = '/api/v1/hr/listofmilitarystatus',

  //maritalStatus
  API_MARITALSTATUS_GETLIST = '/api/v1/hr/listofmartialstatus',

  API_STATUS_GETLIST = '/api/v1/hr/listofhrstatus',

  //Transfering Company APIS
  API_TRANSFERINGCOMPANY_ADD = '/api/v1/bill/addpaymentgateway',
  API_TRANSFERINGCOMPANY_UPDATE = '/api/v1/bill/updatepaymentgateway/',
  API_TRANSFERINGCOMPANY_GETALL = '/api/v1/bill/getallpaymentgateways',
  API_TRANSFERINGCOMPANY_DELETE = '/api/v1/bill/deletepaymentgateway/',
  API_TRANSFERINGCOMPANY_UACTIVEDEACTIVE = '/api/v1/bill/changepaymentgatewayactiveornot/',

  //UNITS
  API_UNITS_ADD = '/api/v1/invt/addunit',
  API_UNITS_UPDATE = '/api/v1/invt/updateunit/',
  API_UNITS_GETALL = '/api/v1/invt/getallunits',
  API_UNITS_DELETE = '/api/v1/invt/deleteunit/',
  API_UNITS_UACTIVEDEACTIVE = '/api/v1/invt/changeunitactiveornot/',
  API_LIST_OF_UNITTYPES = '/api/v1/invt/listofunitstypes',

  //Cars Models APIS
  API_CARS_MODELS_ADD = '/api/v1/Trans/addtranscarmodel',
  API_CARS_MODELS_UPDATE = '/api/v1/Trans/updatetranscarmodel/',
  API_CARS_MODELS_GETALL = '/api/v1/Trans/getcarsmodels',
  API_CARS_MODELS_DELETE = '/api/v1/Trans/removetranscarmodel/',
  API_CHECK_Car_Model_NAMEAR_EXIST = '/api/v1/Trans/IsExistsCarModelNameAr',
  API_CHECK_Car_Model_NAMEEN_EXIST = '/api/v1/Trans/IsExistsCarModelNameEn',

  //Cars expense APIS
  API_CARS_EXPENSE_ADD = '/api/v1/Trans/addtranscarexpensetypes',
  API_CARS_EXPENSE_UPDATE = '/api/v1/Trans/updatetranscarexpensetypes/',
  API_CARS_EXPENSE_GETALL = '/api/v1/Trans/getcarsexpensestypes',
  API_CARS_EXPENSE_GETList = '/api/v1/Trans/listofcarsExpensesTypes',
  API_CARS_EXPENSE_DELETE = '/api/v1/Trans/removetranscarexpensetypes/',
  API_CARS_EXPENSE_UACTIVEDEACTIVE = '/api/v1/Trans/changeexpensetypeactiveandenactiv/',
  API_CARS_EXPENSE_ASSIGN_SALES_UACTIVEDEACTIVE = '/api/v1/Trans/changeexpensetechnicianactiveandenactive/',
  API_GET_CARS_EXPENSES_ADD = '/api/v1/Trans/addtranscarexpense',
  API_GET_CARS_EXPENSES = '/api/v1/Trans/getcarsexpenses',
  API_CARS_EXPENSETRANSACTION_DELETE = '/api/v1/Trans/removetranscarexpense/',
  API_CARS_EXPENSES_IMAGES = '/api/v1/Trans/uploadcarexpensesimages',
  API_CARS_EXPENSES_ACCEPT = '/api/v1/Trans/acceptcarexpense/',
  API_CARS_EXPENSES_REJECT = '/api/v1/Trans/rejectcarexpense/',
  API_CARS_EXPENSES_EXPENSES = '/api/v1/Trans/IsExistsExpenseTypeName',

  // cars
  API_CARS_DROPDOWNS = '/api/v1/Trans/listofcarData',
  API_LISTOF_TECHNITIANS = '/api/v1/tech/listoftechnicians',
  API_CAR_DOWNLOAD_FILE = '/api/v1/Trans/DownloadCarsWithModelsExcelSheet/',
  API_CAR_uplaod_FILE = '/api/v1/Trans/UploadCarsWithModelsBulkData',
  API_CHECK_PLATE_NUMBER_EXIST = '/api/v1/Trans/IsExistsCarPlateNumber',

  //VoucherSerial APIS
  API_VOUCHER_SERIAL_ADD = '/api/v1/bill/addbillsbook',
  API_VOUCHER_SERIAL_GETALL_SEARCH = '/api/v1/bill/getbillsbooksbyfilteration',
  API_VOUCHER_SERIAL_DELETE = '/api/v1/bill/deletebillsbook/',
  API_GET_BILLS_TYPES = '/api/v1/bill/listofbillstypes',

  // unit Conversion
  API_UNIT_CONVERSION_ADD = '/api/v1/invt/addunitofconversion',
  API_UNIT_CONVERSION_GETALL = '/api/v1/invt/getallunitsofconversion',
  API_UNIT_CONVERSION_DELETE = '/api/v1/invt/deleteunitofconversion/',
  API_UNIT_CONVERSION_UACTIVEDEACTIVE = '/api/v1/invt/changeunitofconversionactiveornot/',

  // units
  API_GET_UNITS_RELATEDTO_ITEM_CRITERIA = '/api/v1/invt/getallconvertedunits',
  API_GET_MAIN_UNITS = '/api/v1/invt/getmainunit',
  API_LIST_OF_UNITS = '/api/v1/invt/listofunits',
  API_CHECK_ITEM_NAMEEN_EXISTS = '/api/v1/invt/IsExistsUnitNameEn',
  API_CHECK_ITEM_NAMEAR_EXISTS = '/api/v1/invt/IsExistsUnitNameAr',

  //Region APIS
  API_REGION_ADD = '/api/v1/shared/addregion',
  API_REGION_UPDATE = '/api/v1/shared/updateregion/',
  API_REGION_GETALL = '/api/v1/shared/getallregionsbystateId',
  API_REGION_DELETE = '/api/v1/shared/deleteregion/',
  API_REGION_UACTIVEDEACTIVE = '/api/v1/shared/changeregionactiveornot/',

  //Department APIS
  API_DEPARTMENT_ADD = '/api/v1/hr/adddepartment',
  API_DEPARTMENT_UPDATE = '/api/v1/hr/updatedepartment/',
  API_DEPARTMENT_GETALL = '/api/v1/hr/getdepartments?CompanyId=',
  API_DEPARTMENT_GETALL_v2 = '/api/v2/hr/getdepartments',
  API_DEPARTMENT_DELETE = '/api/v1/hr/deletedepartment/',
  API_DEPARTMENT_UACTIVEDEACTIVE = '/api/v1/hr/changedepartmentactiveornot/',
  API_LIST_OF_DEPARTMENT = '/api/v1/hr/listofdepartments?CompanyId=',
  API_CHECK_DEPARTMENT_NAMEEN_EXIST = '/api/v1/hr/IsExistsDepartmentNameEn',
  API_CHECK_DEPARTMENT_NAMEAR_EXIST = '/api/v1/hr/IsExistsDepartmentNameAr',

  //Section APIS
  API_SECTION_ADD = '/api/v1/hr/addSection',
  API_SECTION_UPDATE = '/api/v1/hr/updateSection/',
  API_SECTION_GETALL = '/api/v1/hr/getSections/',
  API_SECTION_GETALL_v2 = '/api/v2/hr/getSections',
  API_LIST_OF_SECTION = '/api/v1/hr/listOfSections?departmentId=',
  API_SECTION_DELETE = '/api/v1/hr/deleteSection/',
  API_SECTION_UACTIVEDEACTIVE = '/api/v1/hr/changesectionactiveornot/',
  API_CHECK_SECTION_NAMEEN_EXIST = '/api/v1/hr/IsExistsSectionNameEn',
  API_CHECK_SECTION_NAMEAR_EXIST = '/api/v1/hr/IsExistsSectionNameAr',

  //Company APIS
  API_COMPANY_ADD = '/api/v1/shared/addCompany',
  API_COMPANY_UPDATE = '/api/v1/shared/updateCompany/',
  API_COMPANY_GETALL = '/api/v1/shared/getCompanies',
  API_COMPANY_GETBYID = '/api/v1/shared/getcompanyprofile/',
  API_COMPANY_CHANGELOGOWEB = '/api/v1/shared/ChangeLogoWeb',
  API_COMPANY_CHANGELOGOPRINT = '/api/v1/shared/ChangeLogoPrint',
  API_COMPANY_ACTIVEORNOT = '/api/v1/shared/ActiveOrNot/',
  API_COMPANY_GETACTIVE = '/api/v1/shared/listofcompanies',
  API_CHECK_COMPANY_CODE_EXIST = '/api/v1/shared/IsExistsCompanyCode',
  API_CHECK_COMPANY_NAME_EXIST = '/api/v1/shared/IsExistsCompanyName',

  //Branches APIS
  API_BRANCH_ADD = '/api/v1/shared/addcompanybranch',
  API_BRANCH_UPDATE = '/api/v1/shared/updatecompanybranch/',
  API_BRANCH_GETALL = '/api/v1/shared/getcompanybranches',
  API_BRANCH_GETBYID = '/api/v1/shared/getcompanybranchprofile/',
  API_BRANCH_ACTIVEORNOT = '/api/v1/shared/changebranchactiveornot/',
  API_BRANCH_SALESPERSONLOCKUNLOCK = '/api/v1/shared/locktechnicianslogin/',
  API_CHECK_BRANCH_NAME_EXIST = '/api/v1/shared/IsExistsCompanyBranchesName',

  //Employee APIS
  API_GET_EMPLOYEELOOKUP = '/api/v1/hr/listOfEmployees',
  API_GET_EMPLOYEES_DATA = '/api/v1/hr/getofallemployeeswithfilter',
  API_GET_EMPLOYEEBY_ID = '/api/v1/hr/getemployeeprofileinfo',
  API_GET_EMPLOYEEBY_UPDATE_ID = '/api/v1/hr/getemployeeprofile',
  API_ADD_TECHNICIAN = '/api/v1/tech/addtechnicianlog',
  API_GET_TECHNNICIAN_DATA = '/api/v1/tech/gettechnicianlogs',
  API_TOGGLE_EMPLOYEE_ACTIVE = '/api/v1/hr/changeactiveornot',
  API_TOGGLE_EMPLOYEE_TECHNICIAN = '/api/v1/tech/stoptechnician',
  API_CHANGE_EMP_IMAGE = '/api/v1/hr/changeimage',
  API_POST_ADD_EMPLOYEE = '/api/v1/hr/createemployee',
  API_POST_UPDATE_EMPLOYEE = '/api/v1/hr/editemployee/',
  API_EMPLOYEE_EMAIL_AND_MOBIL = '/api/v1/hr/getemailandmobile',
  API_DOWNLOAD_FILE_FOR_EMPLOYEE = '/api/v1/hr/DownloadEmployeesExcelFile',
  API_UPLOAD_EMPLOYEE_DATA = '/api/v1/hr/uploademployees',
  API_GET_EMPLOYEE_ATTENDANCE = '/api/v1/hr/getAttendanceLog',
  API_DOWNLOAD_FILE_FOR_EMPLOYEE_ATTENDANCE = '/api/v1/hr/GetAllEmployeesAttendanceLogPerDayExcel',
  API_DOWNLOAD_FILE_FOR_EMPLOYEE_ATTENDANCE_REPORT = '/api/v1/hr/GetAttendanceLogForAllEmployeesReportExcel',
  API_GET_EMPLOYEE_ATTENDANCE_2 = '/api/v1/hr/GetAttendForEmployeesBetweenTowDates',
  API_EXPORT_EMPLOYEES_TO_EXCEL = '/api/v1/hr/GetEmployeeFiltersBasedExcel',
  API_GET_ALL_EMPLOYEES_WITH_USER = '/api/v1/hr/GetFilterdEmployees',
  API_CHECK_EMPLOYEE_NAME_EXIST = '/api/v1/hr/IsExistsEmployeeName',
  API_CHECK_EMPLOYEE_NID_EXIST = '/api/v1/hr/IsExistsEmployeeNId',
  API_CHECK_EMPLOYEE_EMAIL_EXIST = '/api/v1/hr/IsExistsEmployeeEmail',
  API_CHECK_EMPLOYEE_PHONENUMBER_EXIST = '/api/v1/hr/IsExistsEmployeePhoneNumber',
  API_GET_SYS_MODULES = '/api/v1/Shared/listofsysmodules',

  // Online Users
  API_ONLINE_USERS = '/api/v1/auth/getusers',
  API_ONLINE_USERS_FOREACH_COMPANY = '/api/v1/auth/getnumofonlineusers',
  API_ONLINE_USERES_LASTLOCATION = '/api/v1/tech/getlastlocationforuser',
  API_GET_USER_DATA = '/api/v1/auth/getuserData?isRevamp=true',
  API_USERS_CONNECTION_LOGS = '/api/v1/auth/getuserlogs',
  API_USRS_LOCATION_LOGS = '/api/v1/tech/getlocations',
  API_EMPLOYEE_LOCATION_LOGS = '/api/v1/hr/getalllocationsbyfilterationforemployee',
  API_USRS_ADD_CURRENT_LOCATION = '/api/v1/hr/addemployeelocations',
  API_EXPORT_USERS_TO_EXCEL = '/api/v1/auth/GetCompanyUsersExcelAsync',

  //Users
  API_GET_COMPANY_USERS = '/api/v1/auth/getCompanyUsers',
  API_GET_LIST_OF_USERS = '/api/v1/auth/GetListOfUsers',
  API_GET_USERS_WITH_EMPLOYEE_NAME = '/api/v1/auth/GetListOfUserswithEmployeeName',
  API_USER_REGISTER = '/api/v1/auth/userregister',
  API_EDIT_USER = '/api/v1/auth/updateuser/',
  API_GET_COMPANY_ROLES = '/api/v1/permissions/getrulesforcompany?CompanyId=',
  API_GET_USER_TYPE = '/api/v1/auth/getAllUserTypes',
  API_GET_USER_ROLES = '/api/v1/permissions/getuserroles?UserId=',
  API_UPDATE_USER_ROLES = '/api/v1/permissions/manageuserroles',
  API_RESET_USER_PASSWORD = '/api/v1/auth/resetUserPassWord/',
  API_ACTIVE_USER_OR_NOT = '/api/v1/auth/activateuserornot?UserId=',
  API_DEACTIVATE_VENDOR = '/api/v1/Vend/DeactivateVendor/',
  API_GET_COMPANY_USERS_COUNTS = '/api/v1/permissions/getusersstatistics',

  //Permissions
  API_GET_ROLES_DETAILS_FOR_COMPANY = '/api/v1/permissions/getrolesdetailsforcompany',
  API_GET_DEFAULT_PERMISSIONS_FOR_COMPANY = '/api/v1/permissions/getdefaultpermissionsforcompany/',
  API_MANAGE_PERMISSION_FOR_ROLE = '/api/v1/permissions/managepermissionforrole',
  API_GET_PERMISSIONS_BY_ROLE = '/api/v1/permissions/getpermissionbyrole/',
  API_ADD_ROLE = '/api/v1/permissions/addruleforcompany',
  API_UPDATE_ROLE = '/api/v1/permissions/editroleforcompany/',
  API_DELETE_ROLE = '/api/v1/permissions/deleteruleforcompany/',
  API_GET_COMPAY_ROLES = '/api/v1/permissions/getpermissionforcompanyadmin/',
  API_ADD_COMPANY_ROLES = '/api/v1/permissions/managepermissionforcompanyadmin',
  API_GET_USER_BRANCHES = '/api/v1/auth/getuserbranches?userId=',
  API_CHANGE_PASSWORD = '/api/v1/auth/ChangePassword',
  API_CHECK_ROLE_NAMEEN_EXIST = '/api/v1/permissions/IsExistsRoleNameEn',
  API_CHECK_ROLE_NAMEAR_EXIST = '/api/v1/permissions/IsExistsRoleNameAr',

  //Escalation Matrix
  API_GET_ESCALATION_MATRICES = '/api/v1/EscalationMatrix/GetAll',
  API_GET_ESCALATION_MATRIX_KPIS = '/api/v1/EscalationMatrix/GetKpis',
  API_EXPORT_ESCALATION_MATRICES = '/api/v1/EscalationMatrix/Export',
  API_UPSERT_SERVICE_CATEGORY_ESCALATION = '/api/v1/escalation/upsertservicecategoryescalation',
  API_GET_SERVICE_CATEGORY_ESCALATION_BY_ID = '/api/v1/escalation/getservicecategoryescalationbyid/',
  API_GET_SERVICE_CATEGORY_ESCALATION_DETAILS_BY_ID = '/api/v1/escalation/getservicecategoryescalationdetailsbyid/',
  API_ESCALATION_LIST_APPLICATION_USERS_BY_MODULE = '/api/v1/escalation/listofapplicationusersbymodule',
  API_ESCALATION_LIST_SERVICE_CATEGORIES_BY_MODULE = '/api/v1/escalation/listofservicecategoriesbymodule',

  //Customer
  API_GET_LISTOFCUSTOMER = '/api/v1/cust/listofcustomer?',
  API_GET_CUSTOMERBY_ID_OR_CODE = '/api/v1/cust/getcustomerdataprofile?',
  API_GET_CUSTOMER_BY_EMPID = '/api/v1/cust/getcustomerdatabycollector/',
  API_CUSTOMER_ISCOMPLETE = '/api/v1/cust/changecompleteddataactiveornot/',
  API_CUSTOMER_EMAIL_AND_MOBIL = '/api/v1/cust/getemailandmobile',

  //Customer update
  API_GET_CUSTOMERDATA = '/api/v1/operation/getupdatedcustomers?',
  API_GET_CUSTOMERUPDATETYPE = '/api/v1/operation/listofupdatedcustomertypes',

  //Issue
  API_GET_ISSUEMASTER = '/api/v1/shared/getissues/',
  API_GET_ISSUEDETAILS = '/api/v1/shared/getissuesdetails/',

  //Bills API
  API_GET_BILLS = '/api/v1/shared/getpaymentdata?',

  //Pull Data
  API_PULL_GEOGRAPHIC_DATA = '/api/v1/shared/Managedata',
  API_PULL_EMPLOYEE_DATA = '/api/v1/hr/manageremoteemployeesdata',
  API_PULL_CUSTOMER_DATA = '/api/v1/cust/manageremotecustomers',
  API_PULL_ISSUES_DATA = '/api/v1/shared/manageissue',

  //statics
  API_GET_EMPLOYEE_STATICS = '/api/v1/shared/getdailystatisticsperemployee',
  API_GET_TWELVE_ISSUES_STATICS = '/api/v1/bill/gettoptwelveissues/',
  API_GET_DAILY_STATICS = '/api/v1/shared/getdailystatistics',

  //Menu
  API_GET_ALL_MENU = '/api/v1/permissions/getadminmenu?isRevamp=true',
  API_GET_USER_MENU = '/api/v1/permissions/getmenu?isRevamp=true',
  API_GET_PERMISSIONS_MENU = '/api/v1/permissions/getmenupermissions',
  API_ADD_MENU = '/api/v1/permissions/addpermissionmenuitem?isRevamp=true',
  API_UPDATE_MENU = '/api/v1/permissions/updatepermissionmenuitem',
  API_DELETE_MENU = '/api/v1/permissions/removepermissionmenuitem/',
  API_ACTIVEDEACTIVE_MENU = '/api/v1/permissions/changenodeactivation',

  //financial year
  API_GET_FINANCIAL_YEAR = '/api/v1/shared/getfinancialyears/',
  API_GET_ACTIVE_FINANCIAL_YEAR = '/api/v1/shared/getactivefinancialyear/',
  API_LIST_OF_FINANCIAL_YEAR = '/api/v1/shared/listoffinancialyears/',
  API_ADD_FINANCIAL_YEAR = '/api/v1/shared/addfinancialyear',
  API_DEACTIVE_FINANCIAL_YEAR = '/api/v1/shared/changefinancialyearactiveornot?',
  API_CHECK_FINANCIAL_YEAR = '/api/v1/shared/checkdateinrange?',

  //path route
  API_LIST_OF_STATES = '/api/v1/shared/listofstates',
  API_LIST_OF_REGIONS = '/api/v1/shared/listofregions?',
  API_LIST_OF_TECHNICIAN = '/api/v1/tech/listoftechnicians?companyBranchId=',
  API_LIST_OF_TECHNICIAN_BY_LOCATION = '/api/v1/tech/ListOfTechniciansByProjectIdAsync?companybranchid=',
  API_LIST_OF_PATHROUTE = '/api/v1/route/listofpathroutes?',
  API_GET_PATH_ROUTE = '/api/v1/route/getallpathroutes?',
  API_ADD_PATH_ROUTE = '/api/v1/route/addpathroute',
  API_ACTIVE_DEACTIVE_PATH_ROUTE = '/api/v1/route/changepathrouteactiveornot/',
  API_ASSIGN_PATH_ROUTE_TO_TECHNICAIN = '/api/v1/route/replacetechwithanother?',
  API_UNASSIGN_PATH_ROUTE_TO_TECHNICAIN = '/api/v1/route/removetechfrompathroute?pathRouteId=',

  //CARS
  API_LIST_OF_DRIVER = '/api/v1/hr/listofcardrivers?',
  API_GET_CARS = '/api/v1/Trans/getcars',
  API_ADD_CAR = '/api/v1/Trans/addtranscar',
  API_UPDATE_CAR = '/api/v1/Trans/updatetranscardata/',
  API_Delete_CAR = '/api/v1/Trans/deletetranscardata/',
  API_ASSIGN_CAR_TO_TECHNICAIN = '/api/v1/Trans/assigncartotechnician',
  API_UNASSIGN_CAR_TO_TECHNICAIN = '/api/v1/Trans/unssigncartotechnician',
  API_ASSIGN_CAR_TO_DRIVER = '/api/v1/Trans/assigncartodriver',
  API_UNASSIGN_CAR_TO_DRIVER = '/api/v1/Trans/unssigncartodriver',
  API_LIST_OF_CAR_MODEL = '/api/v1/Trans/listofcarsmodels/',
  API_GET_OF_CAR_LOGS = '/api/v1/Trans/getcarlogs?',
  API_LIST_OF_CARS = '/api/v1/Trans/listofcar',

  //inventory Category
  API_LIST_OF_INVENTORY_CATEGORY = '/api/v1/invt/listofstockcategory?companyId=',
  API_GET_INVENTORY_CATEGORY = '/api/v1/invt/getstockcategorys',
  API_ADD_INVENTORY_CATEGORY = '/api/v1/invt/addstockcategory',
  API_UPDATE_INVENTORY_CATEGORY = '/api/v1/invt/updatestockcategory/',
  API_DELETE_INVENTORY_CATEGORY = '/api/v1/invt/deletestockcategory/',
  API_CHECK_WAREHOUSE_CLASSIFICATION_NAMEAR_EXIST = '/api/v1/invt/IsExistsStockCategoryNameAr',
  API_CHECK_WAREHOUSE_CLASSIFICATION_NAMEEN_EXIST = '/api/v1/invt/IsExistsStockCategoryNameEn',

  //Inventory
  API_REMOVE_ITEM_FROM_INTERNAL_WAREHOUSE = '/api/v1/invt/RemoveItemFromShelf',
  API_GET_INVENTORY = '/api/v1/invt/getallstocks',
  API_LIST_INVENTORY = '/api/v1/invt/listofstocks?companyBranchId=',
  API_LIST_STOCK_KEEPERS = '/api/v1/invt/listofstockkeepes?companyBranchId=',
  API_LIST_MOVABLE_STOCKS = '/api/v1/invt/listofmovablestoresbytype',
  API_LIST_STOCK_MOVEMENTTYPE = '/api/v1/invt/listofstockmovementtypes',
  API_ADD_INVENTORY = '/api/v1/invt/addstock',
  API_DELETE_INVENTORY = '/api/v1/invt/deletestock/',
  API_ACTIVEDEACTIVE_INVENTORY = '/api/v1/invt/changestockactiveornot/',
  API_ASSIGN_EMPLOYEE_TO_INVENTORY = '/api/v1/invt/assignemployeetostock?',
  API_GET_STOCK_KEEPER = '/api/v1/invt/getallstocksKeeperslogs',
  API_GET_STOCK_EMPLYEE = '/api/v1/invt/getallstockemployees',
  API_ASSIGN_EMPLOYEE_TO_STOCK = '/api/v1/invt/addemployeestostock?',
  API_TOGGLE_EMPLOYEE_TO_STOCK = '/api/v1/invt/togglestockemployeeactivation?stockEmployee_Id=',
  API_STOCK_DOWNLOAD_FILE = '/api/v1/invt/DownloadStocksUploadSheet?CompanyId=',
  API_STOCK_uplaod_FILE = '/api/v1/invt/UploadStocksBulkData',
  API_CHECK_WAREHOUSE_CODE_EXIST = '/api/v1/invt/IsExistsStockCode',
  API_CHECK_WAREHOUSE_NAME_EXIST = '/api/v1/invt/IsExistsStockName',

  //Stock Technkique
  API_GET_STOCK_TECHNIQUE = '/api/v1/invt/getstocktechniquelogs',
  API_LIST_OF_STOCK_TECHNIQUE = '/api/v1/invt/listofstocktechnique',
  API_LIST_OF_STOCK_TECHNIQUE_NOT_IN_STOCK = '/api/v1/invt/ListOfEmployeesNotInStock',
  API_ADD_STOCK_TECHNIQUE = '/api/v1/invt/addstocktechniquelog',
  API_DEACTIVE_STOCK_TECHNIQUE = '/api/v1/invt/stopstocktechniquelog',

  //Stock shelfs
  API_LIST_OF_STOCK_SHELFS = '/api/v1/invt/getinvstockshelfs?stockId=',
  API_ADD_STOCK_SHELFS = '/api/v1/invt/addnewstockshelf',
  API_UPDATE_STOCK_SHELFS = '/api/v1/invt/updateinvstockshelfname/',
  API_UPDATE_PARENT_STOCK_SHELFS = '/api/v1/invt/updateinvstockshelfparentid/',
  API_ACTIVE_DEACTIVE_STOCK_SHELFS = '/api/v1/invt/activateordeactivatestockshelf/',
  API_CHECK_STOCK_SHELF_CODE_EXIST = '/api/v1/invt/IsExistsStockShelfCode',
  API_CHECK_STOCK_SHELF_NAME_EXIST = '/api/v1/invt/IsExistsStockShelfName',

  // CLIENT_CATEGORY_APIS
  API_CLIENT_CATEGORY_ADD = '/api/v1/cust/addclientcategory',
  API_CLIENT_CATEGORY_UPDATE = '/api/v1/cust/updateclientcategory/',
  API_CLIENT_CATEGORY_UACTIVEDEACTIVE = '/api/v1/cust/changeclientcategoryactiveornot/',
  API_CLIENT_CATEGORY_GETALL = '/api/v1/cust/getallclientcategories',
  API_CLIENT_CATEGORY_DELETE = '/api/v1/cust/deleteclientcategory/',
  API_CLIENT_CATEGORY_LIST = '/api/v1/cust/listofclientcategories?companyId=',

  // CLIENT_APIS
  API_CLIENT_ADD = '/api/v1/cust/addclientdata',
  API_CLIENT_UPDATE = '/api/v1/cust/updateclientdata/',
  API_CLIENT_UACTIVEDEACTIVE = '/api/v1/cust/changeclientdataactiveornot/',
  API_CLIENT_GETALL = '/api/v1/cust/getclientsdatabyfilteration?',
  API_CLIENT_GETPROFILE = '/api/v1/cust/getclientprofile?',
  API_CLIENT_LIST = '/api/v1/cust/listofclientsdata',
  API_LIST_OF_CLIENT_BY_EMPLOYEE_ID = '/api/v1/Ordering/listofclientsbyemployeeid?Id=',
  API_DOWNLOAD_CLIENT_FILE = '/api/v1/cust/getClientsDataExcelFile?CompanyId=',
  API_CLIENT_EXISTING_CODE = '/api/v1/cust/checkclientcodeisfound',
  API_CLIENT_EXISTING_NAME = '/api/v1/cust/checkclientnameisfound',

  //Client Branches
  API_CLIENTBRANCHES_GETBRANCHES = '/api/v1/cust/getclientbranches?',
  API_CLIENTBRANCH_TOGGLE = '/api/v1/cust/changeclientbranchactiveornot/',
  API_CLIENTBRANCHES_ADD = '/api/v1/cust/addclientbranch',
  API_CLIENTBRANCHES_UPLOADIMAGE = '/api/v1/cust/uploadclientbranchesimages',
  API_CLIENTBRANCHES_UPDATE = '/api/v1/cust/updateclientbranch/',
  API_CLIENTBRANCHES_GETBYID = '/api/v1/cust/getclientbranchprofile?',
  API_ASSIGN_CLIENTBRANCH_TO_PATHROUTE = '/api/v1/cust/assignpathroutetoclientbranch?',
  API_CLIENTBRANCH_PATHROUTE_LOGS = '/api/v1/cust/getclientbranchpathrouteslog?',
  API_CLIENTBRANCH_TO_DEASSIGN_PATHROUTE = '/api/v1/cust/removepathroutefromclientbranch?',
  API_CLIENTBRANCH_GETNOT_ASSIGNEDTO_PATHROUTE = '/api/v1/cust/listofclientsbranchesnotassigned?',
  API_LIST_OF_CLIENT_BRANCH_BY_ID = '/api/v1/cust/listofclientbranches?clientId=',
  API_LIST_OF_CLIENT_BRANCH_BY_EMPLOYEE_ID = '/api/v1/Ordering/listofclientbranchesbyemployeeid?Id=',
  API_LIST_OF_CLIENT_BRANCH_BY_NAME_OR_CODE = '/api/v1/cust/getclientBranchesbynameorcode',
  API_LIST_OF_CLIENT_BRANCH_PROFILE = '/api/v1/cust/getclientbranchprofilebyid?id=',
  API_CHECK_CLIENT_BRANCH_CODE_EXIST = '/api/v1/cust/IsExistClientBranchCode',
  API_CHECK_CLIENT_BRANCH_NAME_EXIST = '/api/v1/cust/IsExistClientBranchName',
  API_CHECK_CLIENT_BRANCH_MOBILE_EXIST = '/api/v1/cust/IsExistClientBranchMobile',
  API_CHECK_CLIENT_BRANCH_SECOND_MOBILE_EXIST = '/api/v1/cust/IsExistClientBranchSecondMobile',

  //items and category
  API_GET_ITEMS_CATEGORY = '/api/v1/invt/getinvitemswithchildrentree/',
  API_GET_ITEMS_NEW = '/api/v1/invt/getinvitems',
  API_CATEGORY_List = '/api/v1/invt/listofinvitemscategories/',
  API_ITEM_CATEGORY_DROPDOWN = '/api/v1/invt/GetItemsCategoryDropDownListTree?companyId=',
  API_CATEGORY_ADD = '/api/v1/invt/addnewinvitemcategory',
  API_CATEGORY_UPDATE = '/api/v1/invt/updateinvitemcategory/',
  API_PARENT_CATEGORY_UPDATE = '/api/v1/invt/changecategoryparentid',
  API_ACTIVE_DEACTIVE_CATEGORY = '/api/v1/invt/changecategoryisactiveornot/',
  API_GET_CATEGORY_OR_SUBCATEGORY = '/api/v1/invt/GetAllCategoryOrSubcategory',
  API_CHECK_CATEGORY_NAME_EN_EXIST = '/api/v1/invt/IsExistsItemCategoryNameEn',
  API_CHECK_CATEGORY_NAME_AR_EXIST = '/api/v1/invt/IsExistsItemCategoryNameAr',

  API_ITEM_ADD = '/api/v1/invt/addnewinvitems',
  API_GET_ITEM_BY_ID = '/api/v1/invt/getinvitemprofile?itemId=',
  API_GET_ITEM_BY_ID_FOR_ORDER = '/api/v1/invt/getitemprofilebyitemid?',
  API_ITEM_UPDATE = '/api/v1/invt/updateinvitems/',
  API_PARENT_ITEM_UPDATE = '/api/v1/invt/changeitemcategory',
  API_ACTIVE_DEACTIVE_ITEMS = '/api/v1/invt/changeitemisactiveornot/',
  API_SEARCH_FOR_ITEMS = '/api/v1/invt/GetInvtItemDataByFilterAsync',
  API_GET_STOCK_TREE = '/api/v1/invt/GetStockShelfsDropDownTree',
  API_ADD_ITEM_TO_SHELLF = '/api/v1/invt/AddItemToStockShelf',
  API_EXPORT_ITEMS_TO_EXCEL = '/api/v1/invt/GetInvtItemDataByFilterExcel?',
  API_LIST_OF_ITEMS = '/api/v1/invt/listofitemsbynameorcode?',
  API_GET_ITEM_PROFILE = '/api/v1/invt/getitemprofilebyid?',
  API_GET_ITEMS_PROFILES = '/api/v1/invt/getitemsprofilesbyids',
  API_GET_ITEMS_LOOKUP = '/api/v1/invt/listofinvitems/',
  API_CHECK_ITEM_BARCODE_EXISTS = '/api/v1/invt/IsExistsItemBarcode',
  API_CHECK_ITEM_CODE_EXISTS = '/api/v1/invt/IsExistsItemCode',
  API_CHECK_ITEM_NAME_EXISTS = '/api/v1/invt/IsExistsItemName',
  API_GET_ITEMS_LIST_PAGINATED = '/api/v1/invt/getinvitemspaginatedlist',
  API_DOWNLOAD_FILE_ITEMS = '/api/v1/invt/GetInvtItemsExcelData',

  //Vendor Activity
  API_LIST_OF_ACTIVITY = '/api/v1/Vend/listofactivities?companyId=',
  API_GET_ACTIVITY = '/api/v1/Vend/getactivities',
  API_ADD_ACTIVITY = '/api/v1/Vend/addactivity',
  API_UPDATE_ACTIVITY = '/api/v1/Vend/updateactivity/',
  API_DELETE_ACTIVITY = '/api/v1/Vend/deleteactivity/',
  API_ACTIVE_DEACTIVE_VENDOR_ACTIVITY = '',
  API_TOGGLE_ACTIVE_DEACTIVE_VENDORACTIVITY = '/api/v1/Vend/DeactivateActivity/',
  API_CHECK_Activity_CODE_EXIST = '/api/v1/Vend/IsExistsActivityCode',
  API_CHECK_Activity_NAMEEN_EXIST = '/api/v1/Vend/IsExistsActivityNameEn',
  API_CHECK_Activity_NAMEAR_EXIST = '/api/v1/Vend/IsExistsActivityNameAr',

  //vendor Main Company
  API_LIST_OF_MAIN_COMPANY = '/api/v1/Vend/listofmaincompanies?companyId=',
  API_GET_MAIN_COMPANY = '/api/v1/Vend/getmaincompanies',
  API_ADD_MAIN_COMPANY = '/api/v1/Vend/addmaincompany',
  API_UPDATE_MAIN_COMPANY = '/api/v1/Vend/updatemaincompany/',
  API_DELETE_MAIN_COMPANY = '/api/v1/Vend/deletemaincompany/',
  API_ACTIVE_DEACTIVE_VENODR_CLASSIFICATION = '/api/v1/Vend/DeactivateClassification/',
  API_CHECK_MAIN_COMPANY_CODE_EXIST = '/api/v1/Vend/IsExistsMainCompanyCode',
  API_CHECK_MAIN_COMPANY_NAMEEN_EXIST = '/api/v1/Vend/IsExistsMainCompanyNameEn',
  API_CHECK_MAIN_COMPANY_NAMEAR_EXIST = '/api/v1/Vend/IsExistsMainCompanyNameAr',

  //Vendor Classification
  API_LIST_OF_CLASSIFICATION = '/api/v1/Vend/listofclassifications?companyId=',
  API_GET_CLASSIFICATION = '/api/v1/Vend/getaclassifications',
  API_ADD_CLASSIFICATION = '/api/v1/Vend/addclassification',
  API_UPDATE_CLASSIFICATION = '/api/v1/Vend/updateclassification/',
  API_DELETE_CLASSIFICATION = '/api/v1/Vend/deleteclassification/',
  API_CHECK_Category_NAMEEN_EXIST = '/api/v1/Vend/IsExistsClassificationNameEn',
  API_CHECK_Category_NAMEAR_EXIST = '/api/v1/Vend/IsExistsClassificationNameAr',

  //Vendor
  API_LIST_OF_VENDOR = '/api/v1/Vend/listofvendors?companyId=',
  API_GET_VENDOR = '/api/v1/Vend/getVendors?companyId=',
  API_ADD_VENDOR = '/api/v1/Vend/addVendor',
  API_ADD_VENDORS_RANGE = '/api/v1/vend/AddVendorsRange',
  API_UPDATE_VENDOR = '/api/v1/Vend/updateVendor/',
  API_DELETE_VENDOR = '/api/v1/Vend/deletevendor/',
  API_DOWNLOAD_FILE_VENDOR = '/api/v1/vend/DownloadVendorsExcelFile',
  API_CHECK_VENDOR_CODE_EXIST = '/api/v1/Vend/IsExistsVendorCode',
  API_CHECK_VENDOR_NAME_EXIST = '/api/v1/Vend/IsExistsVendorName',

  //Tax Office
  API_TAX_OFFICE_ADD = '/api/v1/shared/addtaxoffice',
  API_TAX_OFFICE_UPDATE = '/api/v1/shared/updatetaxoffice/',
  API_TAX_OFFICE_UACTIVEDEACTIVE = '/api/v1/shared/changetaxofficeactiveornot/',
  API_TAX_OFFICE_DELETE = '/api/v1/shared/deletetaxoffice/',
  API_TAX_OFFICE_GETALL = '/api/v1/shared/gettaxoffices?companyId=',

  API_LIST_OF_COMPANY_BRANCH = '/api/v1/shared/listofcompanybranches?companyId=',

  //Transaction
  API_GET_TRANSACTION = '/api/v1/invt/getallstocktransactions?',
  API_LIST_OF_TRANSTYPE = '/api/v1/invt/listofstocktranstypes',
  API_LIST_OF_ENTITYTYPE = '/api/v1/invt/listofentitiestypes',
  API_LIST_OF_EXTERNAL_PLACES = '/api/v1/vend/listofexternalplaces?companyId=',
  API_GET_DOCUMENT_NUMBER = '/api/v1/invt/getnextdocumentnumber?',
  API_ADD_TRANSACTION = '/api/v1/invt/addstocktransaction',
  API_TRANSACTION_ATTACHMENT = '/api/v1/invt/addstocktransattachments',
  API_GET_ITEM_TRANSACTION = '/api/v1/invt/getallstocktransbyitemid?',
  API_UPDATE_RESERVED = '/api/v1/invt/updatereservedamountforstocktrans',
  API_DELETE_RESERVED = '/api/v1/invt/deactivereservedquantity?reservedQuantityId=',
  API_GET_TRANSFER_TRANSACTION = '/api/v1/invt/getallstocktransactionstransfer?',
  API_GET_ENTITY_TYPE_BY_TRANS_TYPE_ID = '/api/v1/invt/getentitiesperstocktranstype',
  API_UPDATE_ENTITY_TYPE_BY_TRANS_TYPE_ID = '/api/v1/invt/manageentitiesperstocktranstype',
  API_GET_PRICE = '/api/v1/invt/getavgpriceforitem?',
  API_LIST_OF_COMMMITTEE = '/api/v1/Committee/listofcommittee',
  API_GET_COMMITTEES = '/api/v1/Committee/GetAllCommittee',

  //Riffles
  API_ADD_COUNTING_PROCESS = '/api/v1/invt/addstockcountingprocess',
  API_GET_RIFFLE_BY_ID = '/api/v1/invt/getprofilecountingprocess?CountingProcessId=',
  API_GET_RIFFLE_DATA = '/api/v1/invt/getcountingprocess',
  API_UPDATE_FINAL_SAVE = '/api/v1/invt/countingprocessfinalsaved?CountingProcessId=',
  API_UPDATE_STTELLEMENT_SAVE = '/api/v1/invt/countingprocesssettlement?CountingProcessId=',

  //Notifications
  API_GET_FCMCONFIG = '/api/v1/notification/getallfcmconf',
  API_POST_ADDFCMCONF = '/api/v1/notification/addfcmconf',
  API_PUT_UPDATEFCMCONF = '/api/v1/notification/updatefcmconf/',
  API_DELETE_DELETEFCMCONF = '/api/v1/notification/deletefcmconf/',

  API_GET_NotiModules = '/api/v1/permissions/GetAllPermGroups',
  API_GET_NotiModules_BY_ID = '/api/v1/permissions/GetPermGroupProfile?Id=',
  API_POST_ADDNotiModules = '/api/v1/permissions/AddPermGroup',
  API_PUT_UPDATENotiModules = '/api/v1/permissions/UpdatePermGroups/',
  API_DELETE_DELETENotiModules = '/api/v1/permissions/DeletePermGroup/',
  API_TOGGLE_EMPLOYEE_GROUPS_ACTIVE = '/api/v1/permissions/ToggelStatusAsync?Id=',

  API_GET_NOTIFICATION_BY_USER_ID = '/api/v1/notification/getusermessages?',
  API_LIST_OF_MESSAGE_TYPE = '/api/v1/notification/getallmessagetypes',

  API_GET_LISTOFCOMMITTEEMEMBERS = '/api/v1/Committee/listofcommitteemembers',
  API_GET_GETCOMMITTEEMEMBERS = '/api/v1/Committee/getcommitteemembers',
  API_POST_ADDCOMMITTEEMEMBERS = '/api/v1/Committee/addcommitteemember',
  API_PUT_UPDATECOMMITTEEMEMBERS = '/api/v1/Committee/updatecommitteemember/',
  API_DELETE_COMMITTEEMEMBERS = '/api/v1/Committee/deletecommitteemember/',
  API_GET_TOGGLEACTIVEDEACTIVEMember = '/api/v1/Committee/ToggleMemberActivation/',
  API_CHECK_MEMBER_NAME_EXIST = '/api/v1/Committee/IsExistCommitteeMemberName',

  API_GET_LISTOFCOMMITTEETYPES = '/api/v1/Committee/listofcommitteetypes?BranchId=',
  API_POST_ADDCOMMITTEETYPES = '/api/v1/Committee/addcommitteetype',
  API_PUT_UPDATECOMMITTEETYPES = '/api/v1/Committee/updatecommitteetype/',
  API_DELETE_COMMITTEETYPES = '/api/v1/Committee/deletefcommitteetype/',
  API_CHECK_COMMITTEETYPES_NAME_EXIST = '/api/v1/Committee/IsExistCommitteeTypeName',

  API_GET_GETCOMMITTEES = '/api/v1/Committee/getcommittee',
  API_GET_GETCOMMITTEEMEMBERSDETAILS = '/api/v1/Committee/getcommitteemembersdetails',
  API_POST_ADDCOMMITTEE = '/api/v1/Committee/addcommittee',
  API_PUT_UPDATECOMMITTEE = '/api/v1/Committee/updatecommittee/',
  API_DELETE_COMMITTEE = '/api/v1/Committee/deletecommittee/',
  API_GET_TOGGLEACTIVEDEACTIVECOMMITTEE = '/api/v1/Committee/ToggleCommitteeActivation?id=',

  API_GET_STOCKS_BY_TRANS_TYPE_ID = '/api/v1/invt/getstocksperstocktranstype',
  API_UPDATE_STOCKS_TYPE_BY_TRANS_TYPE_ID = '/api/v1/invt/managestocksperstocktranstype',

  //orders
  API_ADD_ORDER = '/api/v1/Ordering/addorder',
  API_GET_ORDERS = '/api/v1/Ordering/getorders?',
  API_GET_STATISTICS_ORDERS = '/api/v1/Ordering/getstatisticsforemployee?',

  //Ordering status
  API_GET_LISTOFORDERSTATUS = '/api/v1/Ordering/listoforderstatus',
  API_GET_GETORDERSTATUS = '/api/v1/Ordering/getallorderstatus',
  API_POST_ADDORDERSTATUS = '/api/v1/Ordering/addorderstatus',
  API_PUT_UPDATEORDERSTATUS = '/api/v1/Ordering/updateorderstatus/',
  API_DELETE_ORDERSTATUS = '/api/v1/Ordering/deleteorderstatus/',

  API_GET_LISTOFEMPLOYEE = '/api/v1/hr/listofemployees',
  API_GET_GetEMPLOYEHAVECLIENTSEBYCOMPANYID = '/api/v1/Ordering/listofemployeeshaveclientsbycompanyid',
  API_GET_GETCLIENTSBYEMPLOYEEID = '/api/v1/Ordering/getclientsbyemployeeid',
  API_POST_MANAGECLIENTSOFEMPLOYEE = '/api/v1/Ordering/manageclientsofemployee',
  API_GET_PRERECIEVED_ORDER = '/api/v1/Ordering/getprereceivedorder?',

  API_GENERATE_RECIEVED_CODE = '/api/v1/Ordering/generatereceivedcode?OrderReceivedId=',

  API_ADD_RECIEVED_ORDER = '/api/v1/Ordering/addorderreceived',
  API_GET_RECIEVED_ORDER = '/api/v1/Ordering/getallordersreceived?',
  API_REFUSED_ITEM = '/api/v1/Ordering/refusedorderitems',
  API_ORDER_NEXT_STATUS = '/api/v1/Ordering/ordernextstatus?',
  API_RECEIVED_ORDER_NEXT_STATUS = '/api/v1/Ordering/receivedordernextstatus',
  API_POST_TRANS_RECIEVEDLOAD = '/api/v1/Ordering/addstocktranstocar',

  //ItemPricing
  API_GET_ITEMPricing = '/api/v1/invt/getallitempricing',
  API_GET_ClientCategories = '/api/v1/cust/listofclientcategories',
  API_GET_Client = '/api/v1/cust/getclientsdatabyfilteration',
  API_GET_ClientBranches = '/api/v1/cust/listofclientbranches',
  API_PUT_ChangeActivation = '/api/v1/invt/changeactiveornotactiveitempricing',
  API_PUT_UnitOfConversionByItem = '/api/v1/invt/getunitsofconversionbyitemid',
  API_POST_AddItemPricing = '/api/v1/invt/additempricing',

  //recieved Load
  API_POST_RECIEVEDLOAD = '/api/v1/Ordering/addorderreceivedloading',
  API_GET_RECIEVEDLOAD = '/api/v1/Ordering/getallordersreceivedloading',

  //Purchase
  API_GET_PURCHASE = '/api/v1/Purshase/GetPOData',
  API_GET_PURCHASE_DATA = '/api/v1/Purshase/GetPOProfileData?id=',
  API_ADD_PURSHASE = '/api/v1/Purshase/AddPO',
  API_PUT_PURSHASE = '/api/v1/Purshase/UpdatePO',
  API_POST_ATTACHMENT_FILES = '/api/v1/Purshase/AddPOAttachments',
  API_POST_CHANGE_PO_STATUS = '/api/v1/Purshase/ChangePOStatus',

  //other Costs
  API_GET_OTHER_COASTS = '/api/v1/Purshase/GetOtherCostTypes',

  //Purchase lists
  API_GET_CURRENCY_RATES = '/api/v1/Purshase/ListOfCurrencyRates',
  API_GET_PAYMENT_TYPES = '/api/v1/Purshase/ListOfPayTypes',
  API_GET_PAYMENT_METHODS = '/api/v1/Purshase/ListOfPayMethods',
  API_GET_PURCHASE_STATUS = '/api/v1/Purshase/ListOfStatus',
  API_GET_VENDOR_PROFILE = '/api/v1/Vend/GetVendorProfile/',

  //Po Recived
  API_GET_RECEIVED_PURCHASE = '/api/v1/Purshase/GetRecivedPOData',
  API_ADD_RECEIVED_PURSHASE = '/api/v1/Purshase/AddRecivedPO',
  API_POST_PO_STOCK_TRANS = '/api/v1/Purshase/addpostocktrans',
  API_GET_ITEMS_LOCATIONS = '/api/v1/invt/GetItemsStockShelf',

  // othercoasts
  API_DELETE_OTHER_COSTS = '/api/v1/Purshase/DeleteCostType?TypeId=',
  API_ADD_OTHERCOAST = '/api/v1/Purshase/AddCostType',
  API_CHANGE_OTHERCOAST_ISACTIVE = '/api/v1/Purshase/UpdateActiveorInActive?typeId=',
  API_UPDATE_OTHERCOAT_CATEGORY = '/api/v1/Purshase/UpdateCostType?CostId=',

  //openBalance
  API_GET_OPEN_BALANCE_EXCEL_SHEET = '/api/v1/invt/GetBeginBalanceItemsExcelFile?CompanyId=',
  API_ADD_OPEN_BALANCE = '/api/v1/invt/createbeginbalance',

  // ColorLooUp
  API_COLOR_ADD = '/api/v1/shared/addcolor',
  API_COLOR_UPDATE = '/api/v1/shared/updatecolor/',
  API_COLOR_UACTIVEDEACTIVE = '/api/v1/shared/changecoloractiveornot/',
  API_COLOR_DELETE = '/api/v1/shared/deletecolor/',
  API_COLOR_GETALL = '/api/v1/shared/getcolors?companyId=',
  API_COLOR_LIST_OF = '/api/v1/shared/listofcolors?companyId=',

  // Brandlookup
  API_BRAND_ADD = '/api/v1/shared/addbrand',
  API_BRAND_UPDATE = '/api/v1/shared/updatebrand/',
  API_BRAND_UACTIVEDEACTIVE = '/api/v1/shared/changebrandactiveornot/',
  API_BRAND_DELETE = '/api/v1/shared/deletebrand/',
  API_BRAND_GETALL = '/api/v1/shared/getbrands',
  API_BRAND_LIST_OF = '/api/v1/shared/listofbrands?companyId=',
  API_CHECK_BRAND_NAMEAR_EXIST = '/api/v1/shared/IsExistsBrandNameAr',
  API_CHECK_BRAND_NAMEEN_EXIST = '/api/v1/shared/IsExistsBrandNameEn',

  // CountrieyLookUp
  API_COUNTRY_ADD = '/api/v1/shared/addcountry',
  API_COUNTRY_UPDATE = '/api/v1/shared/updatecountry/',
  API_COUNTRY_UACTIVEDEACTIVE = '/api/v1/shared/changecountryactiveornot/',
  API_COUNTRY_DELETE = '/api/v1/shared/deletecountry/',
  API_COUNTRY_GETALL = '/api/v1/shared/getcountries?companyId=',
  API_COUNTRY_LIST_OF = '/api/v1/shared/listofcountries?companyId=',

  // YearLookUp
  API_PRODUCTIONYEAR_GETALL = '/api/v1/shared/listofproductionyears',

  ////////////////////// mainTainance  ///////////////////////////////////////////////////////////////////////////

  // assets
  API_PROFILE_ASSETS = '/api/v1/Assets/GetAssetProfile',
  API_GETALL_ASSETS = '/api/v1/Assets/GetAllAssets',
  API_GETALL_ASSETS_HAS_SC = '/api/v1/Assets/GetAllAssetsWithSC',
  API_GETALL_WARRNTY_STATUS = '/api/v1/Assets/ListOfAssetWarrantyStatus',
  API_ADD_ASSETS = '/api/v1/Assets/AddAsset',
  API_ADD_ASSETS_BULK = '/api/v1/Assets/UploadAssetsBulkData',
  API_DELETE_ASSETS = '/api/v1/Assets/DeleteAsset?assetId=',
  API_DEACTIVE_ASSETS = '/api/v1/Assets/DeactivateAsset?assetId=',
  API_DROPDOWN_ASSETS = '/api/v1/Assets/GetAssetsDropDownList',
  API_SEARCH_ASSETS_WITH_CODE_NAME = '/api/v1/Assets/AutoCompleteAssets',
  API_UPLOAD_FILES_FOR_ASSETS = '/api/v1/Assets/SaveAssetAttachmentFiles',
  API_ASSETS_DOWNLOAD_FILE = '/api/v1/Assets/DownloadAssetsUploadSheet',
  API_ADD_LOCATION_ASSETS = '/api/v1/uploadBulkData/UploadBulkClientBranchLocationsWithAssets',
  API_ASSETS_HISTORY_BY_ASSETID = '/api/v1/Assets/GetAssetHistory?assetId=',
  API_UPDATE_SOME_ASSETS_DATA = '/api/v1/Assets/UpdateAssets',
  API_GET_ASSET_SERVICE_CATEGORIES = '/api/v1/Assets/GetAssetServiceCatigories',
  API_ADD_BULK_RC = '/api/v1/uploadBulkData/uploadRCsBulkData',
  API_DOWNLOAD_RC_BULK_FILE = '/api/v1/uploadBulkData/DownloadRCsExcelSheet',
  API_CHECK_ASSETS_INTERNAL_CODE_EXIST = '/api/v1/Assets/IsExistAssetInternalCode',
  API_CHECK_ASSETS_SERIAL_NUMBER_EXIST = '/api/v1/Assets/IsExistAssetSerialNumber',

  // servicesCategory
  API_LISTOF_SERVICESCATEGORY = '/api/v1/ServiceCategory/GetServiceCategoryDropDownlistTree?CompanyId=',
  API_GETALL_SERVICESCATEGORY = '/api/v1/ServiceCategory/GetAllServiceCategories',
  API_GETALL_AS_TREE_SERVICESCATEGORY = '/api/v1/ServiceCategory/GetServiceCategoryDropDownlistTree',
  API_PROFILE_SERVICESCATEGORY = '/api/v1/ServiceCategory/GetServiceCategoryProfile?categoryId=',
  API_PROFILE_ROUTINE_CHECK_SERVICESCATEGORY = '/api/v1/ServiceCategory/GetRoutineCheckServiceCategoryProfile?categoryId=',
  API_UPSERT_ROUTINE_CHECK_SERVICESCATEGORY = '/api/v1/ServiceCategory/UpsertRoutineCheckServiceCategory',
  API_ADD_SERVICESCATEGORY = '/api/v1/ServiceCategory/CreateServiceCategories',
  API_DELETE_SERVICESCATEGORY = '/api/v1/ServiceCategory/DeleteServiceCategories?categoryId=',
  API_UPDATE_SERVICESCATEGORY = '/api/v1/ServiceCategory/UpdateServiceCategories',
  API_UPLOAD_FILES_FOR_SERVICES_CATEGORY = '/api/v1/ServiceCategory/SaveServiceCategoryAttachmentFiles',
  API_GET_LIST_OF_SERVICESCATEGORY = '/api/v1/ServiceCategory/GetAllAssetServiceCategoriesAsync',
  API_SERVICE_CATEGORY_BULK_DOWNLOAD_TEMPLATE = '/api/v1/ServiceCategory/bulkupload/downloadtemplate',
  API_SERVICE_CATEGORY_BULK_UPLOAD = '/api/v1/ServiceCategory/bulkupload/upload',
  API_GET_RATES = '/api/v1/Shared/listofrates',
  API_ADD_RATE = '/api/v1/serviceRequest/addservicerequestrate',
  API_GET_ALL_RATES = '/api/v1/serviceRequest/getallrates',
  API_CHECK_SERVICE_CATEGORY_NAMEEN_EXIST = '/api/v1/ServiceCategory/IsExistsServiceCategoryNameEn',
  API_CHECK_SERVICE_CATEGORY_NAMEAR_EXIST = '/api/v1/ServiceCategory/IsExistsServiceCategoryNameAr',
  API_GETALL_SERVICE_CATEGORY_PRIORITIES = '/api/v1/ServiceCategory/GetAllServiceCategoryPriorities',
  API_GET_DROPDOWN_SERVICE_CATEGORY_PRIORITIES = '/api/v1/ServiceCategory/GetDropDownListOfServiceCategoryPriorities',
  API_PROFILE_SERVICE_CATEGORY_PRIORITY = '/api/v1/ServiceCategory/GetServiceCategoryPriorityProfile?id=',
  API_UPSERT_SERVICE_CATEGORY_PRIORITY = '/api/v1/ServiceCategory/UpsertServiceCategoryPriority',
  API_DELETE_SERVICE_CATEGORY_PRIORITY = '/api/v1/ServiceCategory/DeleteServiceCategoryPriority?id=',
  API_UPLOAD_FILES_SERVICE_CATEGORY_PRIORITY = '/api/v1/ServiceCategory/SaveServiceCategoryPriorityAttachmentFiles',
  API_GET_PRIORITY_BY_SERVICE_CATEGORY = '/api/v1/ServiceCategory/GetPriorityByServiceCategory',

  // instructions
  API_GET_SERVICE_CATEGORY_BY_ASSETID = '/api/v1/ServiceCategory/GetServiceCategoryByAsset?asset_Id=',
  API_GET_SERVICE_CATEGORY_BY_CLIENTBRANCHID = '/api/v1/MaintTeams/GetAllServiceCategoriesByClientBranchId',
  API_INSTRUCTIONS_ADD = '/api/v1/ServiceCategory/CreateInstructions',
  API_INSTRUCTIONS_UPDATE = '/api/v1/ServiceCategory/UpdateInstructions',
  API_INSTRUCTIONS_UACTIVEDEACTIVE = '/api/v1/ServiceCategory/DeactivateInstruction/',
  API_INSTRUCTIONS_DELETE = '/api/v1/ServiceCategory/DeleteInstructions/',
  API_INSTRUCTIONS_GETALL = '/api/v1/ServiceCategory/GetAllInstructions',
  API_INSTRUCTIONS_LIST_OF = '/api/v1/ServiceCategory/ListOfInstructions',
  API_CHECK_INSTRUCTIONS_NAMEAR_EXIST = '/api/v1/ServiceCategory/IsExistsInstructionNameAr',
  API_CHECK_INSTRUCTIONS_NAMEEN_EXIST = '/api/v1/ServiceCategory/IsExistsInstructionNameEn',

  // instructions Group
  API_INSTRUCTIONS_GROUP_ADD = '/api/v1/ServiceCategory/AddInstructionsGroup',
  API_INSTRUCTIONS_GROUP_DELETE = '/api/v1/ServiceCategory/DeleteInstructionsGroup?GroupId=',
  API_INSTRUCTIONS_GROUP_GET_PROFILE = '/api/v1/ServiceCategory/GetInstructionGroupProfile?GroupId=',
  API_INSTRUCTIONS_GROUP_GET_DROPDOWN = '/api/v1/ServiceCategory/GetInstructionsGroupDropDownList',
  API_INSTRUCTIONS_GROUP_LIST_OF = '/api/v1/ServiceCategory/ListOfInstructionGroups',
  API_INSTRUCTIONS_GET_ALL = '/api/v1/ServiceCategory/GetAllInstructionGroups',
  API_CHECK_INSTRUCTIONS_GROUP_NAMEAR_EXIST = '/api/v1/ServiceCategory/IsExistsInstructionsGroupNameAr',
  API_CHECK_INSTRUCTIONS_GROUP_NAMEEN_EXIST = '/api/v1/ServiceCategory/IsExistsInstructionsGroupNameEn',
  API_CHECK_INSTRUCTIONS_GROUP_DESCRIPTION_EXIST = '/api/v1/ServiceCategory/IsExistsInstructionsGroupDescription',

  // priorites
  API_PRIORITIES_ADD = '/api/v1/ServiceCategory/createpriorities',
  API_PRIORITIES_UPDATE = '/api/v1/ServiceCategory/updatepriorities',
  API_PRIORITIES_DELETE = '/api/v1/ServiceCategory/Deletepriorities?PriorityId=',
  API_PRIORITIES_GETALL = '/api/v1/ServiceCategory/getallpriorities',
  API_PRIORITIES_LIST_OF = '/api/v1/ServiceCategory/listofprioriteis?companyId=',
  API_CHECK_PRIORITIES_NAMEEN_EXIST = '/api/v1/ServiceCategory/IsExistsPriorityNameEn',
  API_CHECK_PRIORITIES_NAMEAR_EXIST = '/api/v1/ServiceCategory/IsExistsPriorityNameAr',

  // teams
  API_GET_TEAMS_TREE = '/api/v1/MaintHub/GetMaintHubTree/',
  API_CHANGE_HUB_LEVEL = '/api/v1/MaintHub/changeHubparentid',
  API_ADD_ASSIGN_TEAM_TO_HUB = '/api/v1/MaintHub/AssignTeamstoHub',
  API_DELETE_TEAM_FROM_HUB = '/api/v1/MaintHub/DeleteTeamFromHub?Id=',
  API_GET_TEAMS_BY_HUBID = '/api/v1/MaintHub/GetTeamsByHub/',
  API_CHANGE_HUB_STATUS = '/api/v1/MaintHub/ActivateHub/',
  API_DELETE_HUB = '/api/v1/MaintHub/deleteMaintHub/',
  API_GET_HUB_PROFILE = '/api/v1/MaintHub/GetMaintHubProfile/',
  API_UPDATE_HUB = '/api/v1/MaintHub/updateMaintHub/',
  API_ADD_HUB = '/api/v1/MaintHub/addnewMaintHub',
  API_TEAMS_STATISTICS_FOR_TABLE = '/api/v1/GetLocationsWithTeamNumbers',
  API_TEAMS_STATISTICS_FOR_REGIONS = '/api/v1/GetTeamsStatisticsForRegionsClientLocations',
  API_TEAMS_STATISTICS_FOR_LOCATIONS = '/api/v1/GetTeamsStatisticsForLocation',
  API_TEAMS_STATISTICS_FOR_TEAMS = '/api/v1/GetTeamStatisticsForLastLevelLocations',
  API_TEAMS_ADD = '/api/v1/MaintTeams/AddTeam',
  API_TEAMS_DELETE = '/api/v1/MaintTeams/DeleteTeam?teamId=',
  API_TEAMS_UNASSIGN_STOCK = '/api/v1/MaintTeams/UnAssignStockFromTeam?teamId=',
  API_TEAMS_GETALL = '/api/v1/MaintTeams/GetAllTeams',
  API_TEAMS_LIST_OF = '/api/v1/MaintTeams/ListOfTeams',
  API_TEAMS_UACTIVEDEACTIVE = '/api/v1/MaintTeams/DeactivateTeam?teamId=',
  API_TEAMS_PROFILE = '/api/v1/MaintTeams/GetTeamProfile',
  API_TEAMS_TEAM_DATA = '/api/v1/MaintTeams/GetTeamMembersData',
  API_TEAMS_UPLOAD_BULK = '/api/v1/MaintTeams/UploadTeamsBulkData',
  API_UPLOAD_ASSIGN_TO_STOCK = '/api/v1/MaintTeams/UploadAssignStockToTeamsBulkData',
  API_TEAMS_DOWNLOAD_BULK_FILE = '/api/v1/MaintTeams/DownloadTeamsBulkData',
  API_GET_TECH_DATA = '/api/v1/tech/GetAllTechniciansData',
  API_DELETE_TEAM_MEMBER = '/api/v1/MaintTeams/DeleteTeamMember?teamId=',
  API_ADD_NEW_TEAM_MEMBERS = '/api/v1/MaintTeams/AddTeamMembersToTeam?stockId=',
  API_TOGGLE_SUPERVISOR_TEAM_MEMBER = '/api/v1/MaintTeams/MakeTechnicianSupervisor?teamId=',
  API_CHECK_TEAM_NAME_EXIST = '/api/v1/MaintTeams/IsExistsTeamName',
  API_GET_TEAM_MEMBERS = '/api/v1/MaintTeams/GetListOfTeamMembers?teamId=',
  API_TEAMS_STATUS_TOTAL_COUNT = '/api/v1/MaintTeams/GetTeamsStatusTotalCount?companyId=',
  API_TEAMS_STATUS_COUNT_BER_HUB = '/api/v1/MaintTeams/GetTeamsStatusCountBerHub?companyId=',
  API_TEAMS_STATUS_BY_AREA = '/api/v1/MaintTeams/GetTeamsStatusByArea?companyId=',

  // workFlowSteps
  API_WORK_FLLOW_STEPS_ADD = '/api/v1/ServiceCategory/createworkflowstep',
  API_WORK_FLLOW_STEPS_UPDATE = '/api/v1/ServiceCategory/updateworkflowstep',
  API_WORK_FLLOW_STEPS_DELETE = '/api/v1/ServiceCategory/deleteworkflowstep?StepId=',
  API_WORK_FLLOW_STEPS_UACTIVEDEACTIVE = '/api/v1/ServiceCategory/deactivateworkflowstep?StepId=',
  API_WORK_FLLOW_STEPS_GETALL = '/api/v1/ServiceCategory/getallworkflowsteps',
  API_WORK_FLLOW_STEPS_LIST_OF = '/api/v1/ServiceCategory/listofworkflowsteps',
  API_CHECK_STEPS_NAMEAR_EXIST = '/api/v1/ServiceCategory/IsExistsWFStepNameAr',
  API_CHECK_STEPS_NAMEEN_EXIST = '/api/v1/ServiceCategory/IsExistsWFStepNameEn',

  // workFlowSteps action
  API_WORK_FLLOW_STEPS_ACTION_ADD = '/api/v1/ServiceCategory/createworkflowstepactiontype',
  API_WORK_FLLOW_STEPS_ACTION_UPDATE = '/api/v1/ServiceCategory/updateworkflowstepactiontype',
  API_WORK_FLLOW_STEPS_ACTION_DELETE = '/api/v1/ServiceCategory/deleteworkflowstepactiontype?actionTypeId=',
  API_WORK_FLLOW_STEPS_ACTION_UACTIVEDEACTIVE = '/api/v1/ServiceCategory/deactivateworkflowstepactiontype?actionTypeId=',
  API_WORK_FLLOW_STEPS_ACTION_GETALL = '/api/v1/ServiceCategory/getallworkflowstepactiontypes',
  API_WORK_FLLOW_STEPS_ACTION_LIST_OF = '/api/v1/ServiceCategory/listofworkflowstepactiontypes',
  API_CHECK_STEPS__ACTION_SYSNAME_EXIST = '/api/v1/ServiceCategory/IsExistsWorkflowStepActionTypeSysName',
  API_CHECK_STEPS_ACTION_NAMEAR_EXIST = '/api/v1/ServiceCategory/IsExistsWorkflowStepActionTypesNameAr',
  API_CHECK_STEPS_ACTION_NAMEEN_EXIST = '/api/v1/ServiceCategory/IsExistsWorkflowStepActionTypesNameEn',

  // workFlowSteps Group
  API_WORK_FLLOW_STEPS_GROUP_ADD = '/api/v1/ServiceCategory/AddWorkFlowStepsGroup',
  API_CHECK_WORK_FLLOW_STEPS_GROUP_ISEXIST = '/api/v1/ServiceCategory/CheckWorkFlowStepsGroupIsExist',
  API_WORK_FLLOW_STEPS_GROUP_ADD_ACTIONS = '/api/v1/ServiceCategory/AddWorkflowStepActions',
  API_WORK_FLLOW_STEPS_GROUP_DELETE = '/api/v1/ServiceCategory/DeleteWorkFlowStepsGroup?groupId=',
  API_WORK_FLLOW_STEPS_GROUP_PROFILE = '/api/v1/ServiceCategory/GetWorkFlowStepGroupProfile?groupId=',
  API_WORK_FLLOW_STEPS_GROUP_GETALL = '/api/v1/ServiceCategory/GetAllWorkFlowStepsGroups',
  API_WORK_FLLOW_STEPS_GROUP_LIST_OF = '/api/v1/ServiceCategory/ListOfWorkFlowStepsGroups',
  API_WORK_FLLOW_STEPS_GROUP_GET_ACTIONS = '/api/v1/ServiceCategory/getallworkflowstepactions?step_Id=',
  API_WORK_FLLOW_STEPS_GROUP_UPDATE_ACTIONS = '/api/v1/ServiceCategory/updateworkflowstepaction',

  // spareParts

  API_DELETE_SPAREPARTS = '/api/v1/ServiceCategory/deleteworkflowstep',
  API_DEACTIVATE_SPAREPARTS = '/api/v1/ServiceCategory/deactivateworkflowstep',

  //  locations
  API_LOCATIONS_ADD = '/api/v1/Assets/createassetlocation',
  API_LOCATIONS_UPDATE = '/api/v1/Assets/updateassetlocation',
  API_LOCATIONS_DELETE = '/api/v1/Assets/deleteassetlocation?LocationId=',
  API_LOCATIONS_GETALL = '/api/v1/Assets/getallassetslocations',
  API_LOCATIONS_GETALL_ASSET_FOR_SPECIFIC_LOCATION = '/api/v1/Assets/GetAllAssetsForSpecificLocation',
  API_LOCATIONS_DROPDOWN = '/api/v1/Assets/getassetslocationsdropdownlist',
  API_LOCATIONS_DROPDOWN_WITHOUT_PARAMS = '/api/v1/Assets/GetAssetsLocationsDropDownListByUser',
  API_LOCATIONS_DEACTIVE = '/api/v1/Assets/deactivateLocation?locationId=',

  // Asset Locations Group

  API_ADD_LOCATION_TO_GROUP = '/api/v1/AssetLocationsGroup/AddAssetLocationPermGroup',
  API_TOGGLE_LOCATION_TO_GROUP = '/api/v1/Assets/ToggleAssetLocationPermGroupActivation?Id=',
  API_DELETE_LOCATION_TO_GROUP = '/api/v1/AssetLocationsGroup/DeleteAssetLocationPermGroup?Id=',
  API_DELETE_EMPLOYEE_FROM_GROUP = '/api/v1/permissions/deletepermgroupuser?',

  API_GET_GROUPS_TO_LOCATION = '/api/v1/AssetLocationsGroup/GetGroupsByAsset?location_Id=',
  API_UPDATE_PARENT_LOCATION = '/api/v1/AssetLocationsGroup/changelocationparent?',
  API_GET_ASSIGNED_LOCATION_BY_USER = '/api/v1/AssetLocationsGroup/GetAssignedLocationsByUser?user_Id=',
  API_DOWNLOAD_EXCEL_FOR_LOCATIONS = '/api/v1/uploadBulkData/DownloadProjectBulkDataExcel',
  API_UPLOAD_EXCEL_DATA_FOR_LOCATIONS = '/api/v1/uploadBulkData/uploadprojectbulkdata?LocationId=',

  // status
  API_STATUS_ADD = '/api/v1/Assets/CreateAssetStatus',
  API_STATUS_UPDATE = '/api/v1/Assets/UpdateAssetStatus',
  API_STATUS_DELETE = '/api/v1/Assets/DeleteAssetStatus?statusId=',
  API_STATUS_GETALL = '/api/v1/Assets/GetAllAssetStatus',
  API_STATUS_LIST_OF = '/api/v1/Assets/ListOfAssetStatus',
  API_STATUS_UACTIVEDEACTIVE = '/api/v1/Assets/DeactivateAssetStatus?statusId=',
  API_CHECK_ASSETS_NAMEEN_EXIST = '/api/v1/Assets/IsExistsAssetStatusNameEn',
  API_CHECK_ASSETS_NAMEAR_EXIST = '/api/v1/Assets/IsExistsAssetStatusNameAr',

  // models
  API_MODELS_ADD = '/api/v1/Assets/CreateModel',
  API_MODELS_UPDATE = '/api/v1/Assets/UpdateModel',
  API_MODELS_DELETE = '/api/v1/Assets/DeleteModel?modelId=',
  API_MODELS_GETALL = '/api/v1/Assets/GetAllModels',
  API_MODELS_LIST_OF = '/api/v1/Assets/ListOfModels',
  API_MODELS_UACTIVEDEACTIVE = '/api/v1/Assets/DeactivateLModel?modelId=',
  API_CHECK_MODELS_NAMEAR_EXIST = '/api/v1/Assets/IsExistsModelNameAr',
  API_CHECK_MODELS_NAMEEN_EXIST = '/api/v1/Assets/IsExistsModelNameEn',

  //serviceRequest
  API_GET_SERVICE_REQUEST_FOR_DASHBOARD = '/api/v1/serviceRequest/GetAllServiceRequestsForDashboard',
  API_LISTOF_MAINTENANCETYPE = '/api/v1/serviceRequest/listofmaintenancetypes',
  API_LISTOF_REQUESTSOURCE = '/api/v1/serviceRequest/listofrequestsourcestypes?isWebDisplay=',
  API_ADD_MAINT_ACTIVITY = '/api/v1/maintActivity/createactivity',
  API_GET_MAINT_ACTIVITY = '/api/v1/maintActivity/getallactivities',
  API_LISTOF_ACTIVITY_TYPE = '/api/v1/maintActivity/listofactivitytypes',
  API_ADD_SERVICE_REQUEST = '/api/v1/serviceRequest/createservicerequest',
  API_LIST_OF_SERVICE_REQUEST = '/api/v1/serviceRequest/findservicerequestids',
  API_LISTOF_STATUS = '/api/v1/serviceRequest/listOfStatusTypes',
  API_GET_SERVICE_REQUEST = '/api/v1/serviceRequest/getAllServiceRequests',
  API_GET_SERVICE_REQUEST_PROFILE = '/api/v1/serviceRequest/getServiceRequestProfile?Id=',
  API_GET_SERVICE_REQUEST_PROFILE_BY_CODE = '/api/v1/serviceRequest/getServiceRequestProfileByCode',
  API_UPLOAD_FILES_FOR_SERVICE_REQUEST = '/api/v1/serviceRequest/savemaintattachmentfiles',
  API_CLOSE_SERVICE_REQUEST = '/api/v1/serviceRequest/closeservicerequest',
  API_GET_STATUS_STATISTICS = '/api/v1/serviceRequest/getstatisticsstatuscount',
  API_REJECTED_SERVICE_REQUEST = '/api/v1/serviceRequest/refuseservicerequest',
  API_CLIENT_SERVICE_REQUEST_STATUS = '/api/v1/serviceRequest/GetAllClientsWithServiceRequestStatus',
  API_CANCLE_SERVICEREQUEST = '/api/v1/serviceRequest/CancelServiceRequest',
  API_CHANGE_SERVICEREQUEST_STATUS = '/api/v1/serviceRequest/changeservicerequeststatus',

  //workorder
  API_ADD_CLIENT_NOTE = '/api/v1/workorder/AddNoteForClient',
  API_ADD_WORK_ORDER = '/api/v1/workorder/createworkorder',
  API_GET_WORKORDER_PROFILE_BY_ID = '/api/v1/workorder/getworkorderprofile?workOrderId=',
  API_GET_All_CALENDER = '/api/v1/workorder/GetAllCalendarWorkorders',
  API_GET_CALENDER = '/api/v1/maintPM/getCalendarPMSchedule',
  API_REJECTED_WORK_ORDER = '/api/v1/workorder/refuseworkorderassign',
  API_DOWNLOAD_PM_BULK_FILE = '/api/v1/uploadBulkData/DownloadPMsExcelSheet',
  API_GET_WORK_ORDER_BY_VENDOR_ID = '/api/v1/workOrder/getCurrentWorkOrders',
  API_GET_WORK_ORDER_BY_ASSET_ID = '/api/v1/workorder/GetAllWorkOrdersByAssetId',
  API_REASSIGN_WORK_ORDER = '/api/v1/workorder/addworkorderassign',
  API_UPLOAD_FILE_FOR_WORK_ORDER = '/api/v1/workorder/AddMaintAttachmentFilesToWO',
  API_CHANGE_WFS_FOR_WORK_ORDER = '/api/v1/workorder/changeworkorderwfstep',
  API_UPDATE_WORK_ORDER = '/api/v1/UpdateWorkOrderReportDescription',

  //PM Template ---> instructions
  API_GET_ALL_PMS = '/api/v1/PreventiveMaintainence/GetAllForms',
  API_GET_ALL_PMS_V2 = '/api/v2/PreventiveMaintainence/GetAllForms',
  API_GET_PMS = '/api/v1/PreventiveMaintainence/GetPms/',
  API_POST_PMS = '/api/v1/PreventiveMaintainence/CreateDynamicForm',
  API_DELETE_DeleteForm = '/api/v1/PreventiveMaintainence/DeleteForm?formId=',
  API_DEACTIVE_PMS = '/api/v1/PreventiveMaintainence/ToggleFormActivation?formId=',
  API_GET_LIST_OF_PMINSTRUCTIONS = '/api/v1/PreventiveMaintainence/ListOfForms',
  API_GET_INPUT_TYPES = '/api/v1/PreventiveMaintainence/GetInputTypesData',
  API_GET_FORM_PROFILE = '/api/v1/PreventiveMaintainence/GetFormProfile?formId=',
  API_GET_FORM_BY_ID = '/api/v1/PreventiveMaintainence/GetFormById?formId=',
  API_POST_CLOSE_WORK_ORDER = '/api/v1/workorder/closeWorkOrder',
  API_EXPORT_PM_TO_EXCEL = '/api/v1/maintPM/GetAllMaintPMsExcelAsync?',
  API_CHECK_INSTRUCTIONS_TEMPLATE_NAME_EXIST = '/api/v1/PreventiveMaintainence/IsExistsDynamicFormName',

  //  schedule
  API_GET_ALL_DAYS = '/api/v1/Shared/listofdays',
  API_GET_ALL_MONTHS = '/api/v1/Shared/listofmonths',
  API_CREATE_SCHEDULE = '/api/v1/maintSchedules/addmaintschedule',
  API_GETALL_SCHEDULE = '/api/v1/maintSchedules/getallmaintschedules',
  API_GET_PROFILE_SCHEDULE = '/api/v1/maintSchedules/getmaintscheduleprofile',

  // PREVENTIVE MAINTENANCE
  API_GET_ALL_PM = '/api/v1/maintPM/getall',
  API_CREATE_PM = '/api/v1/maintPM/addorupdate',
  API_DELETE_PM = '/api/v1/maintPM/delete?id=',
  API_DELETE_PMS = '/api/v1/maintPM/DeleteList',
  API_DEACTIVE_PM = '/api/v1/maintPM/activateordeactivate?id=',
  API_CHANGE_ASSIGN_PM = '/api/v1/maintPM/changeassigntopm',
  API_CHANGE_NAME_PM = '/api/v1/maintPM/changename',
  API_CHANGE_PM_SCHEDULE = '/api/v1/maintPM/ChangePMDueTaskDateTime',
  API_ADD_BULK_PM_WEEKLY = '/api/v1/uploadBulkData/UploadPMsWeeklyBulkData',
  API_ADD_BULK_PM_DAILY = '/api/v1/uploadBulkData/UploadPMsDailyBulkData',

  API_GET_PM_SCHEDULE = '/api/v1/maintPM/getallschedulesbypmid?pmId=',
  API_DELETE_PM_SCHEDULE = '/api/v1/maintSchedules/deletemaintschedule?id=',

  API_GET_PM_ASSETS = '/api/v1/maintPM/getallassetsbypmid?pmId=',
  API_ADD_PM_ASSETS = '/api/v1/maintPM/addassetstopm',
  API_DELETE_PM_ASSETS = '/api/v1/maintPM/removeassetsfrompm',

  API_GET_PM_INSTRUCTION = '/api/v1/maintPM/getallformsbypmid?pmId=',
  API_ADD_PM_INSTRUCTION = '/api/v1/maintPM/addformstopm',
  API_DELETE_PM_INSTRUCTION = '/api/v1/maintPM/removeformsfrompm',
  API_ADD_BULK_PM = '/api/v1/uploadBulkData/uploadPMsBulkData',

  // ROUTINE checks
  API_ADD_ROUTINE_CHECK = '/api/v1/RoutineCheck/AddRoutineCheckSchedules',
  API_GET_ALL_ROUTINE_CHECK_TEMPLATE = '/api/v1/RoutineCheck/GetAllRCTemplates',
  API_GET_ROUTINE_CHECK_PROFILE = '/api/v1/RoutineCheck/GetRCTemplateProfile?id=',
  API_ACTIVE_DEACTIVE_ROUTINE_CHECK = '/api/v1/RoutineCheck/ActivateOrDeactivateRC?id=',
  API_DELETE_ROUTINE_CHECK = '/api/v1/RoutineCheck/DeleteRCTemplate?id=',

  API_ADD_ROUTINE_CHECK_SCHEDULE = '/api/v1/RoutineCheck/AddRC_Schedule',
  API_GET_ALL_ROUTINE_CHECK_SCHEDULE = '/api/v1/RoutineCheck/GetAllMaintSchedulesByRCId?RoutineCheck_Id=',
  API_DELETE_ROUTINE_CHECK_SCHEDULE = '/api/v1/RoutineCheck/DeleteScheadule?',

  API_REFUSEDTYPE_ADD = '/api/v1/MaintRefusedTypes/AddMaintRefusedType',
  API_REFUSEDTYPE_LIST_OF = '/api/v1/MaintRefusedTypes/ListOfMaintRefusedType?companyId=',
  API_REFUSEDTYPE_GETALL = '/api/v1/MaintRefusedTypes/GetAllMaintRefusedType?companyId=',
  API_REFUSEDTYPE_DELETE = '/api/v1/MaintRefusedTypes/DeleteMaintRefusedType/',
  API_REFUSEDTYPE_UACTIVEDEACTIVE = '/api/v1/MaintRefusedTypes/ToggleMaintRefusedTypeActivation/',
  API_REFUSEDTYPE_UPDATE = '/api/v1/MaintRefusedTypes/UpdateMaintRefusedType/',

  API_GET_ALL_ROUTINE_CHECKS = '/api/v1/RoutineCheck/GetAll',
  API_GET_CALENDAR_ROUTINE_CHECKS = '/api/v1/RoutineCheck/GetAllCalendarRoutineChecks',
  API_GET_ROUTINE_CHECKS_PROFILE = '/api/v1/RoutineCheck/GetProfile?id=',

  //////////////////////////////////////// Reports //////////////////////////////////////////////////////////////
  API_GETALL_SPAREPARTS_REPORT_DATA = '/api/v1/Assets/GetSparePartsReportExcel',
  API_EXPORT_SPAREPARTS_REPORT = '/api/v1/Assets/GetSparePartsReport',

  API_GET_WORK_ORDER_REPORT_DATA = '/api/v1/workorder/getallworkorderreport',
  API_DOWNLOAD_WORK_ORDER_REPORT_EXCEL = '/api/v1/workorder/getallworkorderreportexcel',

  API_GET_SERVICE_REQUEST_REPORT_DATA = '/api/v1/serviceRequest/GetAllServiceRequestReport',
  API_DOWNLOAD_SERVICE_REQUEST_REPORT_EXCEL = '/api/v1/serviceRequest/GetAllServiceRequestReportExcel',

  API_GET_CLIENTS_DATA = '/api/v1/cust/GetAllClientsReport',
  API_DOWNLOAD_CLIENTS_EXCEL = '/api/v1/cust/GetAllClientsReportExcel',
  API_GET_ASSETS_DATA = '/api/v1/Assets/GetAssetsReport',
  API_DOWNLOAD_ASSETS_EXCEL = '/api/v1/Assets/GetAssetsReportExcel',

  API_DASHBOARD_PROJECTS_GET_DATA = '/api/v1/GetProjectNameWithStatus',
  API_DASHBOARD_PROJECTS_WITH_STATUS_GET_DATA = '/api/v1/GetProjectWithStatus',
  API_DASHBOARD_PROJECTS_WITH_STATUS_GET_DATA_NEW = '/api/v1/GetProjectResponseAndFixingStatistics',
  API_DASHBOARD_PROJECTS_WORK_ORDER_TIME_REPORT_EXCEL = '/api/v1/GetWorkOrderTimeReportExcel',

  API_DASHBOARD_STATUS_WITH_ASSIGNATION = '/api/v1/GetStatusWithAssignationStatistics',
  API_DASHBOARD_PROJECTS_WITH_CLIENTS = '/api/v1/GetProjectWithClientsStatistics',
  API_DASHBOARD_PROJECTS_WORK_ORDER_TIME_REPORT = '/api/v1/GetWorkOrderTimeReportStatisticsAsync',
  API_GET_ALL_WORK_ORDER_VENDOR = '/api/v1/workorder/GetAllWorkOrderForVendor',

  // Forget Paasword
  API_FORGET_PASSWORD = '/api/v1/auth/ForgetPassword',
  API_VALIDATE_OTP = '/api/v1/auth/ValidateOTP',
  API_CONFIRM_FORGET_PASSWORD = '/api/v1/auth/ForgetPasswordConfirm',

  // Dashboard
  API_GET_PM_CM_STATISTICS = '/api/v1/GetCMAndPMChart',
  API_GET_OFFLINE_ONLINE_TECHNICIANS = '/api/v1/GetOnlineAndOfflineUsersChart',
  API_GET_WO_COUNT_BER_SC = '/api/v1/GetWorkOrderCountBerServiceCategory',
  API_GET_STATUS_COUNT = '/api/v1/GetStatusCountForLocation',

  API_MANAGE_JOB_SECTION = '/api/v1/hr/manageJobSection',
  API_APP_TYPE_LIST_OF = '/api/v1/AppTypes/ListOfAppTypes',
  API_APP_SYSTEM_TYPE_LIST_OF = '/api/v1/AppSystemTypes/ListOfAppSystemTypes',

  // Community Management - Lookups (general settings)
  API_CITY_ADD = '/api/v1/shared/upsertregion',
  API_CITY_GETALL = '/api/v1/shared/getallregions',
  API_CITY_LIST_OF = '/api/v1/shared/listofregions',

  API_AREA_ADD = '/api/v1/shared/upsertArea',
  API_AREA_ACTIVEDEACTIVE = '/api/v1/shared/changeAreaactiveornot/',
  API_AREA_DELETE = '/api/v1/shared/deleteArea/',
  API_AREA_GETALL = '/api/v1/shared/getallAreas',

  API_PETTYPE_ADD = '/api/v1/shared/upsertpettype',
  API_PETTYPE_ACTIVEDEACTIVE = '/api/v1/shared/activatepettype/',
  API_PETTYPE_DELETE = '/api/v1/shared/deletepettype/',
  API_PETTYPE_GETALL = '/api/v1/shared/getallpettypes',
  API_PETTYPE_LIST_OF = '/api/v1/shared/listofpettypes',
  API_PETTYPE_EXISTS_NAME_AR = '/api/v1/shared/IsExistsPetTypeNameAr',
  API_PETTYPE_EXISTS_NAME_EN = '/api/v1/shared/IsExistsPetTypeNameEn',

  API_COM_COLOR_ADD = '/api/v1/color/add',
  API_COM_COLOR_ACTIVEDEACTIVE = '/api/v1/color/activeOrDeActive/',
  API_COM_COLOR_DELETE = '/api/v1/color/delete/',
  API_COM_COLOR_GETALL = '/api/v1/color/getAll',
  API_COM_COLOR_LIST_OF = '/api/v1/color/list',

  API_COM_BRAND_BULK_DOWNLOAD_TEMPLATE = '/api/v1/community/vehiclebrandbulkupload/downloadtemplate',
  API_COM_BRAND_BULK_UPLOAD = '/api/v1/community/vehiclebrandbulkupload/upload',
  API_COM_BRAND_ADD = '/api/v1/community/upsertbrand',
  API_COM_BRAND_ACTIVEDEACTIVE = '/api/v1/community/activatebrand/',
  API_COM_BRAND_DELETE = '/api/v1/community/deletebrand/',
  API_COM_BRAND_GETALL = '/api/v1/community/getAllbrands',
  API_COM_BRAND_LIST_OF = '/api/v1/community/listofbrands',

  API_COM_MODEL_ADD = '/api/v1/community/upsertmodel',
  API_COM_MODEL_ACTIVEDEACTIVE = '/api/v1/community/activatemodel/',
  API_COM_MODEL_DELETE = '/api/v1/community/deletemodel/',
  API_COM_MODEL_GETALL = '/api/v1/community/getallmodels',
  API_COM_MODEL_LIST_OF = '/api/v1/community/listofmodels',

  API_COM_RELATION_ADD = '/api/v1/community/addrelation',
  API_COM_RELATION_UPDATE = '/api/v1/community/updaterelation',
  API_COM_RELATION_ACTIVEDEACTIVE = '/api/v1/community/activaterelation/',
  API_COM_RELATION_DELETE = '/api/v1/community/deleterelation/',
  API_COM_RELATION_GETALL = '/api/v1/community/getallrelations',
  API_COM_RELATION_LIST_OF = '/api/v1/community/GetListOfRelationships',

  // Community Management - Project units (master data)
  API_PROJECT_UNITS_GET_ALL = '/api/v1/units/getallprojectunits',
  API_PROJECT_UNITS_EXPORT = '/api/v1/units/exportprojectunits',
  API_PROJECT_UNITS_GET_ALL_WITH_BLOCK_STATUS = '/api/v1/units/getallprojectunitswithblockstatus',
  API_PROJECT_UNITS_GET_BY_ID = '/api/v1/units/getprojectunit/',
  API_PROJECT_UNITS_LIST_OF = '/api/v1/units/listofprojectunits',
  API_PROJECT_UNITS_UPSERT = '/api/v1/units/upsertprojectunit',
  API_PROJECT_UNITS_DELETE = '/api/v1/units/deleteprojectunit/',
  API_PROJECT_UNITS_IS_EXISTS_NUMBER = '/api/v1/units/isexistsunitnumber',
  API_PROJECT_UNITS_IS_EXISTS_CODE = '/api/v1/units/isexistsunitcode',
  API_PROJECT_UNITS_LIST_DELIVERY_STATUSES = '/api/v1/units/listofdeliverystatuses',
  API_PROJECT_UNITS_LIST_FINISHING_STATUSES = '/api/v1/units/listoffinishingstatuses',
  API_PROJECT_UNITS_LIST_OCCUPANCY_STATUSES = '/api/v1/units/listofoccupancystatuses',
  API_PROJECT_UNITS_LIST_RENTAL_STATUSES = '/api/v1/units/listofrentalstatuses',
  API_PROJECT_UNITS_LIST_UNIT_TYPES = '/api/v1/units/listofunittypes',
  API_PROJECT_UNITS_LIST_AREAS = '/api/v1/ProjectAreas/ListOfProjectAreas',
  API_PROJECT_UNITS_LIST_ZONES = '/api/v1/ProjectZones/ListOfProjectZones',
  API_PROJECT_UNITS_LIST_BUILDINGS = '/api/v1/ProjectBuildings/ListOfProjectBuildings',
  API_PROJECT_UNITS_LIST_FLOORS = '/api/v1/ProjectFloors/ListOfProjectFloors',

  // Community Management - Projects & customers
  API_COMMUNITY_GET_PROJECTS = '/api/v1/community/getallprojects',
  API_COMMUNITY_GET_PROJECT_DETAILS = '/api/v1/community/getprojectbyid/',
  API_COMMUNITY_UPSERT_PROJECT = '/api/v1/community/upsertproject',
  API_COMMUNITY_LIST_OF_PROJECTS = '/api/v1/community/listofprojects',
  API_COMMUNITY_GET_PROJECT_STRUCTURE = '/api/v1/ProjectStructure/GetProjectStructure',
  API_PROJECT_AREAS_UPSERT = '/api/v1/ProjectAreas/UpsertProjectArea',
  API_PROJECT_ZONES_UPSERT = '/api/v1/ProjectZones/UpsertProjectZone',
  API_PROJECT_BUILDINGS_UPSERT = '/api/v1/ProjectBuildings/UpsertProjectBuilding',
  API_PROJECT_FLOORS_UPSERT = '/api/v1/ProjectFloors/UpsertProjectFloor',
  API_PROJECT_PARKING_SLOTS_UPSERT = '/api/v1/ProjectParkingSlots/UpsertProjectParkingSlot',
  API_COMMUNITY_GET_PROJECTS_EXCEL = '/api/v1/community/exportprojects',
  API_COMMUNITY_CHANGE_PROJECT_ACTIVE = '/api/v1/community/activateproject',
  API_COMMUNITY_GET_KPIS = '/api/v1/community/getcommunitykpis',
  API_COMMUNITY_GET_ALL_ACTION_LOGS = '/api/v1/community/getallactionlogs',
  API_SHARED_LIST_OF_PROJECT_TYPES = '/api/v1/shared/listofprojecttypes',
  API_SHARED_LIST_OF_PROJECT_STATUSES = '/api/v1/shared/listofprojectstatuses',
  API_SHARED_LIST_OF_AREAS = '/api/v1/shared/listofAreas',
  API_PROJECT_AREAS_CHANGE_STATUS = '/api/v1/ProjectAreas/ChangeProjectAreaStatus',
  API_PROJECT_ZONES_CHANGE_STATUS = '/api/v1/ProjectZones/ChangeProjectZoneStatus',
  API_PROJECT_BUILDINGS_CHANGE_STATUS = '/api/v1/ProjectBuildings/ChangeProjectBuildingStatus',
  API_PROJECT_FLOORS_CHANGE_STATUS = '/api/v1/ProjectFloors/ChangeProjectFloorStatus',
  API_PROJECT_PARKING_SLOTS_CHANGE_STATUS = '/api/v1/ProjectParkingSlots/ChangeParkingSlotStatus',


  API_COMMUNITY_GET_GROUPS_BY_PROJECT = '/api/v1/community/getgroupsbyproject',
  API_COMMUNITY_ADD_PROJECT_PERM_GROUP = '/api/v1/community/addprojectpermgroup',
  API_COMMUNITY_DELETE_PROJECT_PERM_GROUP = '/api/v1/community/deleteprojectpermgroup',
  API_COMMUNITY_TOGGLE_PROJECT_PERM_GROUP = '/api/v1/community/toggleprojectpermgroupactivation',

  API_COMMUNITY_GET_CUSTOMERS = '/api/v1/community/getcustomers',
  API_COMMUNITY_GET_ALL_CONTRACTS = '/api/v1/community/getallcontracts',
  API_COMMUNITY_EXPORT_CONTRACTS = '/api/v1/community/exportcontracts',
  API_COMMUNITY_LIST_OF_CONTRACT_TYPES = '/api/v1/community/listofcontracttypes',
  API_COMMUNITY_ACTIVATE_CONTRACT = '/api/v1/community/activatecontract',
  API_COMMUNITY_GET_CUSTOMER_BY_ID = '/api/v1/community/getcustomer',
  API_COMMUNITY_ADD_CUSTOMER = '/api/v1/community/addcustomer',
  API_COMMUNITY_UPDATE_CUSTOMER = '/api/v1/community/updatecustomer',
  API_COMMUNITY_LIST_OF_CUSTOMER_TYPES = '/api/v1/community/ListOfCustomersTypes',
  API_COMMUNITY_GET_FAMILY_MEMBERS = '/api/v1/community/getfamilymembers',
  API_COMMUNITY_EXPORT_FAMILY_MEMBERS = '/api/v1/community/exportfamilymembers',
  API_COMMUNITY_ADD_FAMILY_MEMBER = '/api/v1/community/addfamilymember',
  API_COMMUNITY_UPDATE_FAMILY_MEMBER = '/api/v1/community/updatefamilymember',
  API_COMMUNITY_DELETE_FAMILY_MEMBER = '/api/v1/community/deletefamilymember',
  API_COMMUNITY_LIST_OF_RELATIONSHIPS = '/api/v1/community/GetListOfRelationships',
  API_COMMUNITY_CHANGE_CUSTOMER_ACTIVE = '/api/v1/community/Activatecustomer',
  API_COMMUNITY_GET_CUSTOMERS_EXCEL = '/api/v1/community/exportcustomers',
  API_COMMUNITY_DELETE_CUSTOMER = '/api/v1/community/deletecustomer',
  API_COMMUNITY_GET_PETS = '/api/v1/community/getallpets',
  API_COMMUNITY_EXPORT_PETS = '/api/v1/community/exportpets',
  API_COMMUNITY_GET_PET = '/api/v1/community/getpetbyid/',
  API_COMMUNITY_ADD_PET = '/api/v1/community/addpet',
  API_COMMUNITY_UPDATE_PET = '/api/v1/community/updatepet',
  API_COMMUNITY_DELETE_PET = '/api/v1/community/deletepet',
  API_COMMUNITY_GET_CUSTOMER_UNITS = '/api/v1/community/GetUnitsByCustomer',
  API_COMMUNITY_GET_CUSTOMER_ACTIVE_CONTRACT_UNITS = '/api/v1/community/getcustomeractivecontractunits',
  API_COMMUNITY_EXPORT_CUSTOMER_ACTIVE_CONTRACT_UNITS = '/api/v1/community/exportcustomeractivecontractunits',
  API_COMMUNITY_ASSIGN_CUSTOMER_UNIT = '/api/v1/community/AddUnitToCustomer',
  API_COMMUNITY_DELETE_CUSTOMER_UNIT = '/api/v1/community/deletecustomerunit',
  API_COMMUNITY_GET_VEHICLES = '/api/v1/community/getallvehicles',
  API_COMMUNITY_EXPORT_VEHICLES = '/api/v1/community/exportvehicles',
  API_COMMUNITY_ADD_VEHICLE = '/api/v1/community/addvehicle',
  API_COMMUNITY_UPDATE_VEHICLE = '/api/v1/community/updatevehicle',
  API_COMMUNITY_DELETE_VEHICLE = '/api/v1/community/deletevehicle/',
  API_COMMUNITY_SERVICE_CATEGORIES_TREE = '/api/v1/community/comservicecategoriestree',
  API_COMMUNITY_LIST_OF_SERVICE_CATEGORIES_TREE = '/api/v1/community/listofservicecategoriestree',
  API_COMMUNITY_LIST_OF_SERVICE_CATEGORY_CHILDREN = '/api/v1/community/listofservicecategorychildren',
  API_COMMUNITY_GET_SERVICE_CATEGORY_PATH = '/api/v1/community/getservicecategorypath/',
  API_COMMUNITY_TOGGLE_SERVICE_CATEGORY_ACTIVATION = '/api/v1/community/activateservicecategory/',
  API_COMMUNITY_GET_SERVICE_CATEGORY_TECHNICIANS = '/api/v1/community/getservicecategorytechnicians/',
  API_COMMUNITY_CHANGE_TICKET_EMPLOYEE_SHIFT = '/api/v1/community/changeticketemployeeshift',
  API_COMMUNITY_DELETE_SERVICE_CATEGORY = '/api/v1/community/deleteservicecategory/',
  API_COMMUNITY_GET_SERVICE_CATEGORIES_KPIS = '/api/v1/community/getservicecategorieskpis',
  API_COMMUNITY_GET_SERVICE_CATEGORY_BY_ID = '/api/v1/community/getservicecategorybyid/',

  API_COMMUNITY_VIOLATION_TYPES_TREE = '/api/v1/community/violationtypestree/',
  API_COMMUNITY_UPSERT_VIOLATION_TYPE = '/api/v1/community/upsertviolationtype',
  API_COMMUNITY_ACTIVATE_VIOLATION_TYPE = '/api/v1/community/activateviolationtype/',
  API_COMMUNITY_LIST_OF_VIOLATION_TYPES = '/api/v1/community/listofviolationtypes',
  API_COMMUNITY_GET_VIOLATIONS_KPIS = '/api/v1/community/getviolationskpis',
  API_COMMUNITY_GET_VIOLATIONS_MANAGER_KPIS = '/api/v1/community/getviolationsmanagekpis',
  API_COMMUNITY_GET_ALL_VIOLATIONS = '/api/v1/community/getallviolations',
  API_COMMUNITY_GET_VIOLATIONS_MANAGER_APPROVAL = '/api/v1/community/GetViolationsManagerApprovel',
  API_COMMUNITY_EXPORT_VIOLATIONS = '/api/v1/community/exportviolations',
  API_COMMUNITY_ACTIVATE_VIOLATION = '/api/v1/community/activateviolation/',
  API_COMMUNITY_UPSERT_VIOLATION = '/api/v1/community/upsertviolation',
  API_COMMUNITY_ADD_VIOLATION_ATTACHMENT = '/api/v1/community/addviolationattachment',
  API_COMMUNITY_GET_VIOLATION_BY_ID = '/api/v1/community/getviolationbyid?id=',

  API_COMMUNITY_CHANGE_VIOLATION_STATUS = '/api/v1/community/changeviolationstatus',
  API_COMMUNITY_LIST_OF_VIOLATION_STATUSES = '/api/v1/community/listofviolationstatuses',

  API_COMMUNITY_MASTER_DATA_BULK_DOWNLOAD_TEMPLATE = '/api/v1/community/masterdatabulkupload/downloadtemplate',
  API_COMMUNITY_MASTER_DATA_BULK_UPLOAD = '/api/v1/community/masterdatabulkupload/upload',
  API_COMMUNITY_SERVICE_CATEGORY_BULK_DOWNLOAD_TEMPLATE = '/api/v1/community/servicecategorybulkupload/downloadtemplate',
  API_COMMUNITY_SERVICE_CATEGORY_BULK_UPLOAD = '/api/v1/community/servicecategorybulkupload/upload',
  API_COMMUNITY_VIOLATION_TYPE_BULK_DOWNLOAD_TEMPLATE = '/api/v1/community/violationtypebulkupload/downloadtemplate',
  API_COMMUNITY_VIOLATION_TYPE_BULK_UPLOAD = '/api/v1/community/violationtypebulkupload/upload',

  //Contracts
  API_COMMUNITY_ADD_CONTRACT = '/api/v1/community/addcontract',
  API_COMMUNITY_IS_EXIST_CONTRACT_NO = '/api/v1/community/IsExistContractNo',
  API_COMMUNITY_LIST_OF_CUSTOMERS_FOR_CONTRACT = '/api/v1/community/listofcustomers',
  API_COMMUNITY_GET_CUSTOMER_UNITS_BY_TYPE = '/api/v1/community/getcustomerunits',
  API_COMMUNITY_GET_CUSTOMER_PARKING_SLOTS_BY_TYPE = '/api/v1/community/getcustomerparkingslots',
  API_COMMUNITY_UPSERT_SERVICE = '/api/v1/community/upsertcomservicecategory',
  API_COMMUNITY_LIST_OF_SERVICE_CATEGORIES_BY_PROJECT = '/api/v1/community/listofservicecategoriesbyproject/',
  API_COMMUNITY_GET_SERVICE_DETAILS_BY_PROJECT = '/api/v1/community/getservicedetailsbyproject/',
  API_COMMUNITY_RECATEGORIZATION_TICKET = '/api/v1/community/recategorizationticket',
  API_COMMUNITY_GET_SERVICE_CATEGORY_SUPERVISORS = '/api/v1/community/getservicecategorysupervisors/',
  API_COMMUNITY_CHANGE_TICKET_SUPERVISOR = '/api/v1/community/changeticketsupervisor',
  API_COMMUNITY_GET_TICKETS_KPIS = '/api/v1/community/getticketskpis',
  API_COMMUNITY_GET_ALL_TICKETS = '/api/v1/community/getalltickets',
  API_COMMUNITY_EXPORT_TICKETS = '/api/v1/community/exporttickets',
  API_COMMUNITY_GET_MY_TICKETS = '/api/v1/community/getmytickets',
  API_COMMUNITY_GET_TICKET_BY_ID = '/api/v1/community/getticketbyid',
  API_COMMUNITY_GET_HELP_DESK_TICKET_DETAILS = '/api/v1/community/gethelpdeskticketdetails',
  API_COMMUNITY_GET_HELP_DESK_PRIORITY_AND_ASSIGNMENT_TEAM = '/api/v1/community/gethelpdeskticketpriorityandassignmentteam',
  API_COMMUNITY_LIST_OF_TICKET_STATUSES = '/api/v1/community/listofticketstatuses',
  API_TICKET_REASON_GETALL = '/api/v1/community/getallticketreasons',
  API_TICKET_REASON_ADD = '/api/v1/community/addticketreason',
  API_TICKET_REASON_UPDATE = '/api/v1/community/updateticketreason',
  API_TICKET_REASON_DELETE = '/api/v1/community/deleteticketreason/',
  API_TICKET_REASON_UACTIVEDEACTIVE = '/api/v1/community/toggleticketreasonactivation/',
  API_TICKET_REASON_LIST_OF = '/api/v1/community/listofticketreasons?ticketStatusId=',
  API_TICKET_REASON_CHECK_NAMEAR_EXIST = '/api/v1/community/isexiststicketreasonnamear',
  API_TICKET_REASON_CHECK_NAMEEN_EXIST = '/api/v1/community/isexiststicketreasonnameen',
  API_COMMUNITY_GET_UNIT_CALLERS = '/api/v1/community/getunitcallers',
  API_TICKET_LIST_OF_TICKET_TYPES = '/api/v1/Ticket/listoftickettypes',
  API_TICKET_ADD = '/api/v1/Ticket/addticket',
  API_COMMUNITY_CHANGE_TICKET_STATUS = '/api/v1/community/changeticketstatus',
  API_COMMUNITY_ADD_TICKET_ACTIVITY = '/api/v1/community/addticketactivity',
  API_COMMUNITY_ADD_TICKET_ATTACHMENT = '/api/v1/community/addticketattachment',
  API_PROJECT_PARKING_SLOTS_LIST_OF_AVAILABLE = '/api/v1/ProjectParkingSlots/ListOfAvailableParkingSlots',
}
